import React from "react";
import * as ACTIONS from "../store/actions/actions";
import { connect } from "react-redux";
import ModalLayout from "./ModalLayout.react";
import ModalLay from "./ModalLay/ModalLay";
import { ActualizarHorariosNavieros } from "../Monitoristas/Monitoreo/panelForms";
import  OperadoresNavieros  from "../Catalogos/OperadoresNavieros/OperadoresNavieros";
import TractosForm from "../Catalogos/Tractos/TractosForm";
import OperadoresForm from "../Catalogos/Operadores/OperadoresForm";
import RemolquesForm from "../Catalogos/Remolques/RemolquesForm";
import { NavieraServiceFailure } from "../Monitoristas";
import { Crud_Catalogos, Crud_error } from "../herramientas/Crud_Catalogos";
import { LoadingScreen } from "../components/LoadingScreen";
import {
  Form,
  Table,
  Alert,
  Icon,
  Dimmer,
  Button,
  List,
  Timeline,
} from "tabler-react";
import { Exportar } from "../herramientas/Excel";
import RuteadorContent from "../pages/RuteadorPage/RuteadorContent";
import Select from "react-select";
import { TablePageable } from "../Helpers";
import EtaCalculada from "../Monitoristas/Monitoreo/panelForms/EtaCalculada";
import { timeToTimeFull, timeToMilisegundos, diff, timeString, timeToYearmonthDay } from "../herramientas/DateFormat";
import { NotificationManager } from "react-notifications";
import { timeToDatefull, milisecondsToHours } from "../herramientas/DateFormat";
import classes from "./EspecificoNaviero.module.css";
import IncidenciasFiltro from "./IncidenciasFiltro";
import DashboardTransportista from "../pages/navBarItems/Dashboards/DashboardTransportista/DashboardTransportista";
import NotificacionesPatios from "../socket/NotificacionesPatios";
import Reporte from "./Reporte";
import TimelineComponent from "./LineaTiempo/TimelineComponent"
import CSVImporter from "../Catalogos/OperadoresNavieros/CargaMasiva/CSVImporter";
import CuentaEspejo from "./CuentaEspejo";
import { validarHorarios, onTime } from './navieras/validaciones';
import VisualizadorArchivos from "./VisualizadorArchivos";
import HistorialMovimiento from "../Catalogos/OperadoresNavieros/HistorialMovimiento";

var user = JSON.parse(sessionStorage.getItem("usuario"));

var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
var idPlataforma = JSON.parse(sessionStorage.getItem("plataforma"));
var transportista = JSON.parse(sessionStorage.getItem("perfil"))?.nombre.includes('Transportista');
var prueba = JSON.parse(sessionStorage.getItem("usuario"))?.username.includes('maersk');

var controlador = JSON.parse(sessionStorage.getItem("perfil"))?.nombre?.toLowerCase().includes('controlador') || JSON.parse(sessionStorage.getItem("perfil"))?.nombre?.toLowerCase().includes('patios')
  || (currentUser && currentUser.some(c => c.perfil?.nombre?.toLowerCase().includes('controlador') || c.perfil?.nombre?.toLowerCase().includes('patios')));

// Permisos para ver historial: Administrador (1), Gerente de Patios (3), Controlador de patios (222), o usuario específico (113633)
var perfilActual = JSON.parse(sessionStorage.getItem("perfil"));
var puedeVerHistorial = [1, 3, 222].includes(perfilActual?.id) || controlador || user?.id === 113633
  || (currentUser && currentUser.some(c => [1, 3, 222].includes(c.perfil?.id)));

//Perfil oneline
const perfilOneLine= currentUser && currentUser.filter(c=> c.perfil && c.perfil.id === 4113).length === 1 ? true: false;

function myFormato(date) {
  function pad(number) {
    if (number < 10) {
      return "0" + number;
    }
    return number;
  }
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    " " +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds())
  );
}
let movsArray = {};
const subDominios = [
  { plataforma: "CMA-APL", dominio: "cliente-cma.skyangel.com.mx" },
  { plataforma: "Maersk", dominio: "intermodalmaersk.com" },
  { plataforma: "MSK-SLV", dominio: "intermodalmaersk.com" },
  { plataforma: "MSK-GTA", dominio: "intermodalmaersk.com" },
  { plataforma: "MSK-HN", dominio: "intermodalmaersk.com" },
  { plataforma: "MSK-NCA", dominio: "intermodalmaersk.com" },
  { plataforma: "MSC", dominio: "msc.skynavieros.com" },
  { plataforma: "Arcor", dominio: "arcor.skynavieros.com" },
  { plataforma: "Hamburg Sud", dominio: "hamburg.skynavieros.com" },
  { plataforma: "CMA-APL", dominio: "apl.skynavieros.com" },
  { plataforma: "CMA-APL", dominio: "cma-cgm.skynavieros.com" },
  { plataforma: "Navieros", dominio: "msc.skynavieros.com" },
  { plataforma: "MSK-GTA", dominio: "localhost:3000" },
];

Date.prototype.getWeekNumber = function() {
  var d = new Date(
    Date.UTC(this.getFullYear(), this.getMonth(), this.getDate())
  );
  var dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
};
class Catalogo extends React.Component {
  constructor(props) {    
    super(props);
    this.state = {

      cambioPlataforma:false,
      showConteoModal:false,
      conteoHorarios: { hmsMenor:0, hmsMayor:0, cptMenor:0, cptMayor:0, cpMenor:0, cpMayor:0 },
      readonly:false,
      listaAlertas:[],
      listaAlertasSinFiltrar:[],
      updateData:false,
      isloading:true,
      autoRefresh: true,
      refreshInterval: 60,
      lastUpdate: new Date().toLocaleString(),
      obtenerMovimientosWaiting: false,
      checked:false,
      idTransportista:null,
      idLocalidad:null,
      controlador:controlador,
      elementosSinfiltrar:[],
      elementosSinEstatus:[],
      banderaActualizada:false,
      localidades:[{"value":0,"label":"Todos"}],
      estatus:[{"value":0,"label":"Todos"},{"value":1,"label":"Asignado"},{"value":2,"label":"Sin Asignacion"}],
      elementos: [],
      movsReport: [],
      movimiento: {},
      entregas: [],
      tableheaderItems: [],
      test: this.categorias_object,
      hiddenModals: false,
      readyData: false,
      loadingEntregas: false,
      message: "",
      ErrorMessage: [],
      showErrormessage: false,
      selectedRow: -1,
      alertasN: {},
      gpsN: {},
      movsGpsEstatus: {},
      plataforma: { value: 0, label: "Todas ...", search: "" },
      funcionalidadesCol: [],
      textBuscar: "",
      movimientoAcumuladores: {},
      colToFilter: "po", //columna a filtrar
      AscDesc: true,
      incidenciaColumna: {col: "", Desc: true},
      incidenciatableheader: [],
      bitacoratableheader:[],
      metodo: "get",
      topics: [],
      excelRender: true,
      activos: true,
      incidenciasReporte: [],
      fecha1: timeToDatefull(
        new Date(
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate(),
            0,
            0,
            0,
            0
          ).getTime() -
            1000 * 60 * 60 * 24 * 7
        ).getTime()
      ),
      fecha2: timeToDatefull(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate(),
          0,
          0,
          0,
          0
        ).getTime()
      ),
      informe3: [],
      reporte3: [],
      informe4: [],
      reporte4: [],
      informe69: [],
      reporte69: [],
      informe70: [],
      reporte70: [],
      informes: {},
      patio: {},
      patioFull: {},
      tractoActualObj: null,
      remolqueActualObj: null,
      remolqueFullActualObj: null,
      showVisualizadorArchivos: false,
      ruteadorModal: null,
      // Modales del formulario de transporte
      modalNuevoOperador: false,
      modalEditarOperador: false,
      modalEditarTracto: false,
      modalEditarRemolque: false,
      movimientoTransporteActual: null,
    };
    this.usuariosLogObject = {
      id: "",
      idBitacoraMonitoreo: 0,
      idUsuario: 0,
      idMovimiento: 0,
      accionFecha: "",
      descripcion: "",
      idPlataformaTipo: 1,
      Navigator: false,
    };
    this.colToFilter = "po";
    this.AscDesc = true;
    this.ErrorMessage = "";
    this.ErrorMessageArray = [];
    this.catalogo = this.props.Ctlogo;
    this.catalogoTem = "";
    this.Catalogo_form = this.props.FCtlogo;
    this.tamanio = this.props.tamanio;
    this.updateStatus_elementos = this.updateStatus_elementos.bind(this);
    this.update_localidades = this.update_localidades.bind(this);
    this.getfuntion = this.getfuntion.bind(this);
    this.content = [];
    //this.colum = this.props.colum | [];
    this.registro = [];
    this.columna = [];
    this.fila = [];
    this.campo = [];
    this.get_Store_Elements = null; //this.props.plataformas_object;//update_Store_Elements
    this.update_Store_Elements = null; //this.props.plataformas_update;
    this.getMensage = false;
    this.plataformas = [];
    this.remolques= {};
    this.movimientoAcumuladores = {};
    this.mensaje = {
      mensaje: "",
      plataforma: "",
      corredor: "",
      vista: "",
      data: null,
      accion: "get",
    };
    this.usuariosCorredores = [];
    this.camposLogisticosNav = [];

    this.movsReport = [];

  
  }

  actualizaEstatusAlertas = (idAlerta) =>{
    this.setState({checked:true})
   
    this.getfuntion(
      "put",
      [],
      "",
      [],
      "navierasAlertas" +
        "/atender/" + idAlerta + "/" + user.id
        ,
      this.eliminaAlertas(idAlerta)
    );

  }


  eliminaAlertas = (alerta) =>{


    let newLista = [];
    this.state.listaAlertas.forEach(element => {
      if(element.id != alerta ){
        newLista.push(element)
    }})

  
    this.setState({listaAlertas:newLista})
    this.setState({checked:false})
    
  }


  updateAlertas = (lista,plataforma = this.state.plataforma.value) =>{ 

    this.setState({listaAlertasSinFiltrar:lista})


    let newLista = [];
    let localidades = [];
    
    this.state.localidades.forEach(localidad =>{
      localidades.push(localidad.value)
    })
        this.state.elementos.forEach(m=>  {
          let banderaPlataforma = false;
          
          lista.forEach(element => {

            if(plataforma == 0 && this.plataformas.filter(p=> m.idPlataforma?.id == (p.value)).length && m.id == element.idMovimiento && controlador){
               
                banderaPlataforma =  true
                element.transportista = m?.idTransportista?.nombre
                newLista.push(element)
            }else if(plataforma > 0 && m.idPlataforma?.id == plataforma && m.id == element.idMovimiento){      
              banderaPlataforma =  true
              element.transportista = m?.idTransportista?.nombre
              newLista.push(element)
            }
          
          
          })

          });
    
    if(newLista){
   
        this.setState({listaAlertas:newLista})
    }

    this.setState({isloading:false});
   
  }

  estaPrivilegioActivo = (clave) => {
    var privilegios = this.props.privilegios_object;
    var perfil = JSON.parse(sessionStorage.getItem("perfil"));
    for (let i = 0; i < privilegios.length; i++) {
      if (privilegios[i].clave === clave) {
        if (
          perfil.privilegios.filter(
            (word) => word.idPrivilegio === privilegios[i].id
          ).length > 0
        ) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  cambioLocalidad = (localidad) =>{
   
    let tipoGps = !isNaN(this.props.gpsTipo) ? this.props.gpsTipo : "0";
    this.getfuntion(
      "get",
      [],
      "",
      [],
      "navieraMovimientosPerfil" +
        "/usuario_transportista/" +
        user.id + "/localidad/" + localidad.value + "/" + tipoGps,
      this.update_Store_Elements
    );
    
  }


  insertarNotificaciones = (data,body) =>{
    
      this.state.elementosSinfiltrar.forEach(m=>  {
                      
        if(m.id == data.navierasAlertas.idMovimiento){

            data.navierasAlertas.transportista = m?.idTransportista?.nombre;

            NotificationManager.success( 
                body.mensaje
            );

            this.updateData(data.movimientosPatio)

      
            this.setState({ listaAlertas: [...this.state.listaAlertas, data.navierasAlertas] }) 
            
        }
          
  })
    
  }


  actualizaListadeElementos = (info) =>{


    let updateData = [...this.state.elementos];
    let updateDataNoFiltrado = [...this.state.elementosSinfiltrar];
    
    if(info.accion == 'delete'){



      let index = updateData.findIndex((element)=> element.id == info.data.id)
      let indexNoFiltrado = updateDataNoFiltrado.findIndex((element)=> element.id == info.data.id)
      if (index !== -1) {
        updateData.splice(index,1);
       
      }
      if (indexNoFiltrado !== -1) {
        updateDataNoFiltrado.splice(indexNoFiltrado,1);
       
      }
     
    }

    if(info.accion == 'post'){
      updateData.push(info.data)
      updateDataNoFiltrado.push(info.data)

    }


    if(info.accion == 'update'){
      let index = updateData.findIndex((element)=> element.id == info.data.id)
      let indexNoFiltrado = updateDataNoFiltrado.findIndex((element)=> element.id == info.data.id)

      if (index !== -1) {

        // if(updateData[index].movimientosPatios != null){
        //   let esFull =  null
          
        //   updateData.movimientosPatios.forEach(mp => mp.esFull != null ? esFull = m.esFull : esFull = null );

        //   if(esFull){
        //     let full = updateData.find(mov => mov.id == esFull) || null;
        //     if(full){
        //       // Actualizar movimientosGps aun movimiento full con solo un gps colocado
        //       full.movimientoGps = info.data.movimientoGps;
        //     }
            
        //   }

        // }

        this.actualizaMovFullGps(updateData,index,info);
        updateData[index].movimientoGps = info.data.movimientoGps; 
       
      }
      if (indexNoFiltrado !== -1) {
        this.actualizaMovFullGps(updateDataNoFiltrado,indexNoFiltrado,info);
        updateDataNoFiltrado[indexNoFiltrado].movimientoGps = info.data.movimientoGps; 
       
      }
    }

   

    this.setState({elementosSinfiltrar: updateDataNoFiltrado});
    this.setState({elementos: updateData});
    this.setState({updateData:true})
  }

//Metodo que asigna un gps a un mov enfullado que solo cuenta con gps asignado
  actualizaMovFullGps = (elementos,index,newData) =>{
    if(elementos[index].movimientosPatios != null){
          let esFull =  null
          elementos[index].movimientosPatios.forEach(mp => mp.esFull != null ? esFull = mp.esFull : esFull = null );

          if(esFull){
          
            let full = elementos.find(mov => mov.id == esFull) || null;
            if(full && (full.movimientoGps == null  || full.movimientoGps[0] == null )){
              // Actualizar movimientosGps aun movimiento full con solo un gps colocado
              full.movimientoGps = newData.data.movimientoGps;
              
            }
            
          }

        }
  }

  componentDidUpdate = (previousProps) => {


    if (this.state.elementos !== this.props.movimientos_naviera_object) {
      //this.props.setMovimientosNavieros(this.state.elementos);
    }
    if (this.props.alertasN !== this.state.alertasN) {
      this.setState({ alertasN: this.props.alertasN });
    }
    if (this.props.gpsNavieroReciente !== this.state.gpsN) {
      this.setState({ gpsN: this.props.gpsNavieroReciente });
    }
    
    if (this.props.movsGpsEstatus !== this.state.movsGpsEstatus) {
      this.setState({ movsGpsEstatus: this.props.movsGpsEstatus });
    }
    if (this.state.funcionalidadesCol !== this.props.columnas) {
      this.setState({ funcionalidadesCol: this.props.columnas });
      this.table_headers(true);
    }

    if (this.usuariosCorredores !== this.props.usuariosCorredores) {
      // actualiza socket
      this.usuariosCorredores = this.props.usuariosCorredores;
      var topics = [];
      for (let item of this.props.usuariosCorredores) {
        topics.push("/topic/" + item.idPlataforma + "-" + item.idCorredor);
      }
      this.setState({ topics: topics });
    }
  };
  updateMessage = (sms) => {
    this.setState({ message: sms });
  };


  componentDidMount = () => {
    this.crud("get", "", "", "remolquesTipo", "remolquesTipo");
    if (this.catalogo !== "" || this.catalogo !== null) {
      Object.keys(this.props.catalogos).forEach((key) => {
        if (this.catalogo === this.props.catalogos[key]) {
        }
        switch (this.props.catalogos[key]) {
          case "navieraMovimientosPerfil":
            this.obtenerMovimientos();
            break;
          case "movimientosTipo": {
            this.update_Store_Elements = this.props.movimientosTipo_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "clientes": {
            this.update_Store_Elements = this.props.clientes_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              "catalogos/" + this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "service_failure": {
            this.update_Store_Elements = this.props.serviceFaulure_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key] + "/activos",
              this.update_Store_Elements
            );
            break;
          }
          case "navieras": {
            this.update_Store_Elements = this.props.navieras_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "otd": {
            this.update_Store_Elements = this.props.otd_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "plataformas": {
            this.update_Store_Elements = this.props.plataformas_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "rutasEstatus": {
            this.update_Store_Elements = this.props.rutasEstatus_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "transportistas": {
            this.update_Store_Elements = this.props.transportistas_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              "catalogos/" + this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "etiquetas": {
            this.update_Store_Elements = this.props.etiquetas_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "funcionalidades": {
            this.update_Store_Elements = this.props.funcionalidades_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "privilegios": {
            this.update_Store_Elements = this.props.privilegios_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "operacionesEstatus": {
            this.update_Store_Elements = this.props.operacionesEstatus_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "operacionesTipo": {
            this.update_Store_Elements = this.props.operacionesTipo_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }
          case "operadores": {
            this.update_Store_Elements = this.props.operadores_update;
            this.getfuntion(
              "get",
              [],
              "",
              [],
              this.props.catalogos[key],
              this.update_Store_Elements
            );
            break;
          }

          default:
            return;
        }
      });
    }
    this.plataformas.push({ value: 0, label: "Todas ...", search: "" });
    currentUser.map((usr, index) => {
      if (
        usr.plataforma?.plataformaTipo?.nombre?.toUpperCase().includes("NAVIERA")
      ) {
        this.plataformas.push({
          value: usr.plataforma.id,
          label: usr.plataforma.nombre,
          search: usr.plataforma.nombre,
        });
      }
      return usr;
    });
    if(this.plataformas.length === 2){
      this.setState({ plataforma: this.plataformas[1] });
    }
    if( this.state.autoRefresh ){
      this.startAutoRefresh();
    }
  };

  componentWillUnmount = () => {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  };

  toggleAutoRefresh = () => {
    const newAutoRefresh = !this.state.autoRefresh|false;
    this.setState({ autoRefresh: newAutoRefresh });
    
    if (newAutoRefresh) {
      this.startAutoRefresh();
    } else {
      this.stopAutoRefresh();
    }
    
/*
    if (this.state.autoRefresh) {
      this.stopAutoRefresh();
      this.startAutoRefresh();
    }*/
  };

  startAutoRefresh = () => {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
    this.refreshTimer = setInterval(() => {
      if(this.state.activos){
        this.obtenerMovimientos();
      }
      this.setState({ lastUpdate: new Date().toLocaleString() });
    }, this.state.refreshInterval * 1000);
  };

  stopAutoRefresh = () => {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  };

  handleIntervalChange = (e) => {
    const interval = parseInt(e.target.value) || 60;
    if(interval >= 15){
      this.setState({ refreshInterval: interval });
    }else{
      this.setState({ refreshInterval: 15 });
    }
    this.setState({ autoRefresh: false });
  };
  obtenerMovimientos=()=>{
    this.setState({ obtenerMovimientosWaiting: true });
    this.update_Store_Elements = this.props.movimientos_naviera_update;
    let movimientosBy = currentUser[0]
      ? currentUser[0].perfil
        ? currentUser[0].perfil.movimientosBy
          ? currentUser[0].perfil.movimientosBy
          : 0
        : 0
      : 0;

    if (window.location.host.includes("skyone.skyangel.com.mx") || window.location.host.includes("localhost:3000")) {
      movimientosBy = currentUser[0].perfil.movimientosBy;
    } else {
      for (let s of subDominios) {
        if (window.location.host.includes(s.dominio)) {
          for (let cUser of currentUser) {
            if (cUser.plataforma.nombre === s.plataforma) {
              this.crud(
                "get",
                "",
                "",
                "informes/perfil/" + cUser.perfil.id,
                "informes"
              );
              movimientosBy = cUser.perfil.movimientosBy;
              break;
            }
          }
        }
      }
    }
    if (movimientosBy === 1) {
  
      if( Number.isInteger(this.props.mtipo)){
        if( this.props.mtipo === 0 ){
          this.getfuntion(
            "get",
            [],
            "",
            [],
            "navieraMovimientosPerfil/personalizado",
            this.update_Store_Elements
          );
        }else{
          this.getfuntion(
            "get",
            [],
            "",
            [],
            "navieraMovimientosPerfil/personalizado",
              "/personalizado/movimiento_tipo/" + this.props.mtipo,
            this.update_Store_Elements
          );
        }
      }
    }
    if (movimientosBy === 2) {
      
      //corredores
      switch (this.props.mtipo) {
        case 0:
          let tipoGps = '/';
          this.getfuntion(
            "get",
            [],
            "",
            [],
            "navieraMovimientosPerfil/usuario/" + user.id + tipoGps ,
            this.update_Store_Elements
          );
          break;
        default:
          this.getfuntion(
            "get",
            [],
            "",
            [],
            "navieraMovimientosPerfil/usuario/" +
            user.id +
            "/" +
            this.props.mtipo,
            this.update_Store_Elements
          );
          break;
      }
    }

    if (movimientosBy === 4) {
      
      this.setState({readonly:true})

      //transportistas
      switch (this.props.mtipo) {
        case 0:
        
          let tipoGps = '/';
          if(this.props.gpsTipo){
              tipoGps = "/gpstipo/" + this.props.gpsTipo;
          }
          this.getfuntion(
            "get",
            [],
            "",
            [],
            "navieraMovimientosPerfil/usuario_localidad/" +
              user.id + tipoGps,
            this.update_Store_Elements
          );
          break;
        default:
          this.getfuntion(
            "get",
            [],
            "",
            [],
            "navieraMovimientosPerfil/usuario_localidad/" +
            user.id +
            "/" +
            this.props.mtipo,
            this.update_Store_Elements
          );
          break;
      }
    }
    if (movimientosBy === 3) {
      //transportistas
      switch (this.props.mtipo) {
        case 0:
        
          let tipoGps = '/';
          if(this.props.gpsTipo){
              tipoGps = "/gpstipo/" + this.props.gpsTipo;
          }
          this.getfuntion(
            "get",
            [],
            "",
            [],
            "navieraMovimientosPerfil/usuario_transportista/" +
            user.id + tipoGps,
            this.update_Store_Elements
          );

        
          break;
        default:
          this.getfuntion(
            "get",
            [],
            "",
            [],
            "navieraMovimientosPerfil/usuario_transportista/" +
              user.id +
              "/" +
              this.props.mtipo,
            this.update_Store_Elements
          );

          
          break;
      }
    }
  }
  recargarDatosPatio = () => {
    const mov = this.state.movimientoTransporteActual;
    if (!mov) return;
    Crud_Catalogos("movimientosPatio/idMovimiento/" + mov.id, "", "get", "", [], "", "", "", [])
      .then((returnVal) => {
        this.setState({ patio: returnVal, tractoActualObj: null, remolqueActualObj: null, remolqueFullActualObj: null, gpsFijoNombre: null, gpsFijoFullNombre: null });
        // Buscar tracto completo por placa
        if (returnVal.tractorPlaca && mov.idTransportista?.id) {
          Crud_Catalogos("unidadTerNav/idTransportista/" + mov.idTransportista.id, "", "get", "", [], "", "", "", [])
            .then((tractos) => {
              const tractoEncontrado = tractos.find(t => t.placa && t.placa.toLowerCase() === returnVal.tractorPlaca.toLowerCase());
              if (tractoEncontrado) {
                this.setState({ tractoActualObj: tractoEncontrado });
              }
            })
            .catch(err => console.error("Error recargando tracto:", err));
        }
        // Buscar remolque completo por placa
        if (returnVal.remolquePlaca) {
          Crud_Catalogos("remolques", "", "get", "", [], "", "", "", [])
            .then((remolques) => {
              const remolqueEncontrado = remolques.find(r => r.placa && r.placa.toLowerCase() === returnVal.remolquePlaca.toLowerCase());
              if (remolqueEncontrado) {
                this.setState({ remolqueActualObj: remolqueEncontrado });
              }
            })
            .catch(err => console.error("Error recargando remolque:", err));
          // GPS fijo vinculado al remolque
          Crud_Catalogos("remolquesGpsFijos/placa/" + encodeURIComponent(returnVal.remolquePlaca) + "/activo", "", "get", "", [], "", "", "", [])
            .then((vinc) => {
              this.setState({ gpsFijoNombre: (vinc && vinc.gps) ? vinc.gps.nombre : null });
            })
            .catch(() => this.setState({ gpsFijoNombre: null }));
        }
        // Recargar patio full si aplica
        const esFull = mov.movimientosPatios && mov.movimientosPatios.length > 0 ? mov.movimientosPatios[0].esFull : null;
        if (esFull && esFull !== "") {
          Crud_Catalogos("movimientosPatio/idMovimiento/" + esFull, "", "get", "", [], "", "", "", [])
            .then((patioFull) => {
              this.setState({ patioFull: patioFull });
              if (patioFull.remolquePlaca) {
                Crud_Catalogos("remolques", "", "get", "", [], "", "", "", [])
                  .then((remolques) => {
                    const remFullEncontrado = remolques.find(r => r.placa && r.placa.toLowerCase() === patioFull.remolquePlaca.toLowerCase());
                    if (remFullEncontrado) {
                      this.setState({ remolqueFullActualObj: remFullEncontrado });
                    }
                  })
                  .catch(err => console.error("Error recargando remolque full:", err));
                // GPS fijo vinculado al remolque full
                Crud_Catalogos("remolquesGpsFijos/placa/" + encodeURIComponent(patioFull.remolquePlaca) + "/activo", "", "get", "", [], "", "", "", [])
                  .then((vinc) => {
                    this.setState({ gpsFijoFullNombre: (vinc && vinc.gps) ? vinc.gps.nombre : null });
                  })
                  .catch(() => this.setState({ gpsFijoFullNombre: null }));
              }
            })
            .catch(err => console.error("Error recargando patio full:", err));
        }
      })
      .catch(err => console.error("Error recargando datos patio:", err));
  };

  hiddenmodal = () => {
    this.setState({ hiddenModals: !this.state.hiddenModals });
  };

  updateData =  (data) =>{
    let updateData = [];
    let updateDataNoFiltrado = [];
    
    this.state.elementos.forEach((element,i) => {
               
      if(element.id == data.idMovimiento){
    
          element.movimientosPatios =  []; 
          element.movimientosPatios.push(data);
        
      }
      
      updateData.push(element)
    });


    this.state.elementosSinfiltrar.forEach((element,i) => {
               
      if(element.id == data.idMovimiento){
    
        element.movimientosPatios =  []; 
        element.movimientosPatios.push(data);
        
      }
      
      updateDataNoFiltrado.push(element)
    });

    
    this.setState({elementos:updateData});
    this.setState({elementosSinfiltrar:updateDataNoFiltrado});
   
    this.setState({updateData:true})

  }

  filtrarPorConteo = (campo, tipo) => {
    const ahora = new Date().getTime();
    const dosHoras = 1000 * 60 * 60 * 2;
    const filtrados = this.state.elementosSinfiltrar.filter(m => {
      if(!m[campo]) return false;
      if(campo === 'horaMaximaSalida' && (m.salidaTerminalLleno || m.inicioRuta)) return false;
      if(campo === 'citaProgramada' && m.arriboClienteLleno) return false;
      if(campo === 'citaProgramadaTerminal' && (m.arriboDirecionCarga || m.arriboTerminalCargado)) return false;
      const diff = new Date(m[campo]).getTime() - ahora;
      if(diff <= 0) return false;
      return tipo === 'menor' ? diff < dosHoras : diff >= dosHoras;
    });
    this.setState({ elementos: filtrados, showConteoModal: false });
  }

  refresca = (valor) =>{

    this.setState({updateData:valor})
  }

  getfuntion = (
    metodo = "get",
    params = [],
    id = "",
    arraytoUpdate = [],
    catalogoTem = this.catalogo,
    storeFunction = this.update_Store_Elements
  ) => {
    this.usuariosLogObject.idMovimiento = params;
    let objTemp = params;

    if (catalogoTem !== "") {

      Crud_Catalogos(
        catalogoTem,
        this.catalogo,
        metodo,
        id,
        params,
        storeFunction,
        this.state.elementos,
        this.hiddenmodal,
        arraytoUpdate
      )
        .then((returnVal) => {
       
          this.mensaje.accion = metodo;
          this.mensaje.vista = catalogoTem;
          this.setState({ metodo: metodo });
          
          switch (metodo) {
            case "get":
              if (
                catalogoTem.includes( this.catalogo + "/usuario/" + user.id) ||                
                catalogoTem.includes( this.catalogo + "/personalizado") ||//personalizado activos
                catalogoTem.includes( this.catalogo + "/usuario_personalizado") ||//personalizado finalizados(mas bien cita programada)
                catalogoTem.includes(
                  this.catalogo + "/usuario_transportista/" + user.id
                ) || 
                catalogoTem.includes(
                  this.catalogo + "/usuario_transportista/" + user.id + "/localidad/"
                ) ||//personalizado finalizados(mas bien cita programada)
                catalogoTem.includes(
                  this.catalogo + "/usuario_localidad/" + user.id
                ) 
              ) {

                this.setState({ obtenerMovimientosWaiting: false });
                if(catalogoTem.includes("/usuario_transportista/")){

                   //this.ordenarFechaDeMenorAMayor(returnVal);
                   this.setState({idTransportista:returnVal? returnVal[0]?.idTransportista?.id : null})

                }

                this.updateStatus_elementos();
                this.setState({ readyData: true });
                this.setState({ isloading: false });
                setTimeout(
                  () => this.setState({ excelRender: true }),
                  1000 * 5
                );

                if(!this.state.isloading ){
                // this.setState({isloading:true});
                // this.getfuntion(
                //             "get",
                //             [],
                //             "",
                //             [],
                //             "navierasAlertas" +
                //               "/alertaTipo/3565,3598,3599,2482/estatusAtendida/"+
                //               0 +"/usuario/" + user.id,
                //             this.updateAlertas
                //           );
                }
                //Buscamos reportes
                //del subdominio obtenemos la plataforma
                if (window.location.host.includes("skyone.skyangel.com.mx") || window.location.host.includes("localhost:3000")) {
                  this.crud(
                    "get",
                    "",
                    "",
                    "informes/perfil/" + currentUser[0].perfil.id,
                    "informes"
                  );
                } else {
                  for (let s of subDominios) {
                    if (window.location.host.includes(s.dominio)) {
                      //Buscamos el perfil que corresponda a la plataforma
                      for (let cUser of currentUser) {
                        if (cUser.plataforma.nombre === s.plataforma) {
                          //obtener informes del perfil
                          this.crud(
                            "get",
                            "",
                            "",
                            "informes/perfil/" + cUser.perfil.id,
                            "informes"
                          );
                          break;
                        }
                      }
                    }
                  }
                }
              }
              break;
            case "post":
              this.mensaje.data = returnVal;
              this.mensaje.corredor = returnVal.idCorredor?.id;
              this.mensaje.plataforma = returnVal.idPlataforma?.id;
              this.mensaje.mensaje =
                "Nuevo movimiento (" +
                returnVal.id +
                ", plataforma: " +
                returnVal.idPlataforma?.nombre +
                ")";
              this.props.updateStatusMensaje(true);
              this.usuariosLogObject.idBitacoraMonitoreo = 1;
              this.usuariosLogObject.idUsuario = user.id;
              this.usuariosLogObject.idMovimiento = returnVal.id;
              this.usuariosLogObject.idPlataformaTipo = 1;
              this.usuariosLogObject.accionFecha = myFormato(new Date());
              this.usuariosLogObject.descripcion = "Nuevo Movimiento";
              Crud_Catalogos(
                "usuariosLog",
                this.catalogo,
                "post",
                "",
                this.usuariosLogObject
              );
              break;
            case "put":
              this.mensaje.data = returnVal.data;
              this.mensaje.corredor = returnVal.data.idCorredor?.id;
              this.mensaje.plataforma = returnVal.data.idPlataforma?.id;
              this.mensaje.mensaje =
                "Actualización (" +
                returnVal.data.id +
                ", plataforma: " +
                returnVal.data.idPlataforma?.nombre +
                ")";
              this.props.updateStatusMensaje(true);
              this.usuariosLogObject.idBitacoraMonitoreo = 1;
              this.usuariosLogObject.idUsuario = user.id;
              this.usuariosLogObject.idMovimiento = objTemp.id;
              this.usuariosLogObject.idPlataformaTipo = 1;
              this.usuariosLogObject.accionFecha = myFormato(new Date());
              this.usuariosLogObject.descripcion =
                "Actualización de Movimiento";
              if (objTemp.idOperacionEstatus.id === 1) {
                this.usuariosLogObject.idBitacoraMonitoreo = 5;
                this.usuariosLogObject.descripcion = "Se finaliza movimiento";
              }
              Crud_Catalogos(
                "usuariosLog",
                this.catalogo,
                "post",
                "",
                this.usuariosLogObject
              );
              break;
            case "delete":
              this.usuariosLogObject.idBitacoraMonitoreo = 10;
              this.usuariosLogObject.idUsuario = user.id;
              this.usuariosLogObject.accionFecha = myFormato(new Date());
              this.usuariosLogObject.idPlataformaTipo = 1;
              this.usuariosLogObject.descripcion = "Delete: id:" + returnVal.id;
              Crud_Catalogos(
                "usuariosLog",
                this.catalogo,
                "post",
                "",
                this.usuariosLogObject
              );
              break;
            default:
              break;
          }
        })
        .catch((err) => {
          if (
                catalogoTem.includes( this.catalogo + "/usuario/" + user.id) ||                
                catalogoTem.includes( this.catalogo + "/personalizado") ||//personalizado activos
                catalogoTem.includes( this.catalogo + "/usuario_personalizado") ||//personalizado finalizados(mas bien cita programada)
                catalogoTem.includes(
                  this.catalogo + "/usuario_transportista/" + user.id
                ) || 
                catalogoTem.includes(
                  this.catalogo + "/usuario_transportista/" + user.id + "/localidad/"
                ) ||//personalizado finalizados(mas bien cita programada)
                catalogoTem.includes(
                  this.catalogo + "/usuario_localidad/" + user.id
                ) 
              ) {

                this.setState({ obtenerMovimientosWaiting: false });
              }
          console.log("Error: " + err);
          if (err.response) {
            this.setState({ showErrormessage: true });
            this.ErrorMessage = Crud_error(err.response.status, catalogoTem);
            this.ErrorMessageArray.push(
              <Alert type="danger" icon="alert-octagon">
                {" "}
                {this.ErrorMessage}{" "}
              </Alert>
            );
            this.setState({ ErrorMessage: this.ErrorMessageArray });
          } else {
            this.setState({ showErrormessage: true });
            this.ErrorMessage = Crud_error(404, catalogoTem);
            this.ErrorMessageArray.push(
              <Alert type="danger" icon="alert-octagon">
                {" "}
                {this.ErrorMessage}{" "}
              </Alert>
            );
            this.setState({ ErrorMessage: this.ErrorMessageArray });
          }
        });
    }
  };

  filtrosAplicados = (lista)=>{

 
    this.setState({elementos:lista})

  }




  update_localidades = (plataforma) => {

    let localidades = [ {"value": 0,"label": "Todos"}];
 
    let elementosFiltrados = this.state.elementos.filter(m=> plataforma.value?  m.idPlataforma?.id === plataforma.value : true ); 
   
     if(elementosFiltrados.length > 0){
        for( let m of elementosFiltrados ) {
          if(!m.idLocalidad) continue;

          let object = {"value": m.idLocalidad.id,"label": m.idLocalidad.nombre}
        
          let encontrado = localidades.findIndex((localidad) => localidad.value == m.idLocalidad.id ) ;

          if(encontrado == -1){
          localidades.push(object);
          }
       
        }
      }
      this.setState({localidades:localidades});
     
  }

  ordenarFechaDeMenorAMayor =(movs)=>  {
     let  citasOrdenadas =  null;
    if(movs !=  null){
      citasOrdenadas = [...movs].sort((a, b) => {
      // Convertir las cadenas de fecha a objetos Date
      const fechaA = new Date(a.citaProgramada);
      const fechaB = new Date(b.citaProgramada);
      // Comparar fechas (orden ascendente: B - A)
      return fechaA - fechaB;
      });
    }

   return citasOrdenadas;

  };

  updateStatus_elementos = () => {


    let movsListTemp = [];
    let localidades = [ {"value": 0,"label": "Todos"}];
    if(this.props.movimientos_naviera_object){

      for( let m of this.props.movimientos_naviera_object ) {
          if(m.movimientosPatios?.length > 0 && m.movimientoGps?.length> 0){
            let esFull = null;
            m.movimientosPatios.forEach(mp => {if(mp.esFull != null)esFull = mp.esFull});
          
            if(esFull > 0){
                 let full = this.props.movimientos_naviera_object.find(mov => mov.id == esFull) || {};
                 if(full.movimientoGps?.length <= 0){
                     full.movimientoGps = m.movimientoGps;
                 }
            }

          }

          if(m.idPlataforma?.plataformaTipo?.id === 1){
           if(m.idLocalidad) {
             let object = {"value": m.idLocalidad.id,"label": m.idLocalidad.nombre}
           
             let encontrado = localidades.findIndex((localidad) => localidad.value == m.idLocalidad.id ) ;

             if(encontrado == -1){
               localidades.push(object);
             }
           }
          }
        
          movsListTemp.push(m);
          try{
            if(typeof movsListTemp[movsListTemp.length-1].variables === "string"){
              movsListTemp[movsListTemp.length-1].variables= JSON.parse(movsListTemp[movsListTemp.length-1].variables);
            }
          }catch(e){
            movsListTemp[movsListTemp.length-1].variables= null;
          }
      } 

      if(this.state.localidades.length == 1){
        this.setState({localidades:localidades});
      }

    }


    /**Ordenamos los servicios por cita programada */
    if(movsListTemp.length > 0){
      movsListTemp =  this.ordenarFechaDeMenorAMayor(movsListTemp)
    }

    // Calcular conteos por horaMaximaSalida, citaProgramadaTerminal y citaProgramada
    if(movsListTemp.length > 0){
      const ahora = new Date().getTime();
      const dosHoras = 1000 * 60 * 60 * 2;
      let hmsMenor = 0, hmsMayor = 0;
      let cptMenor = 0, cptMayor = 0;
      let cpMenor = 0, cpMayor = 0;
      for(let m of movsListTemp){
        if(m.horaMaximaSalida && !m.salidaTerminalLleno && !m.inicioRuta){
          const diff = new Date(m.horaMaximaSalida).getTime() - ahora;
          if(diff > 0 && diff < dosHoras) hmsMenor++;
          else if(diff >= dosHoras) hmsMayor++;
        }
        if(m.citaProgramadaTerminal && !m.arriboDirecionCarga && !m.arriboTerminalCargado){
          const diff = new Date(m.citaProgramadaTerminal).getTime() - ahora;
          if(diff > 0 && diff < dosHoras) cptMenor++;
          else if(diff >= dosHoras) cptMayor++;
        }
        if(m.citaProgramada && !m.arriboClienteLleno){
          const diff = new Date(m.citaProgramada).getTime() - ahora;
          if(diff > 0 && diff < dosHoras) cpMenor++;
          else if(diff >= dosHoras) cpMayor++;
        }
      }
      this.setState({ conteoHorarios: { hmsMenor, hmsMayor, cptMenor, cptMayor, cpMenor, cpMayor } });
    }

    this.setState({elementosSinfiltrar: movsListTemp})
    this.setState({ elementos: movsListTemp });
    this.setState({updateData:true})
    if (this.props.movimientos_naviera_object) {
      this.setState({ movsReport: movsListTemp });
    }
    this.props.setMovimientosNavieros(
      this.props.movimientos_naviera_object
        ? this.props.movimientos_naviera_object
        : []
    );
    if (this.state.informe3 && this.props.movimientos_naviera_object) {
      if (this.state.informe3.length > 0) {
        let movsTemp = [];
        this.props.movimientos_naviera_object.map((m, index) => {
          movsTemp[index] = {};
          for (let item of this.state.informe3) {
            movsTemp[index][item.label] = m[item.nombre];
          }
          return m;
        });
        this.setState({ reporte3: movsTemp });
      }
    }
    if (this.state.informe4 && this.props.movimientos_naviera_object) {
      if (this.state.informe4.length > 0) {
        let movsTemp = [];
        this.props.movimientos_naviera_object.map((m, index) => {
          movsTemp[index] = {};
          for (let item of this.state.informe4) {
            movsTemp[index][item.label] = m[item.nombre];
          }
          return m;
        });
        this.setState({ reporte4: movsTemp });
      }
    }
  };

  obtenerColumnas=()=>{
    let columnasTemp= [
      /*
        { 
          columna: "id",
          label: "Id",
          //enClick:(e) => setCurrentMovimiento(e), //enClickDisabled: (e)=> false,//e.idSolicitud === 303? false: true,
          //form: (e)=> <i className="fa fa-edit" style={{"font-size": "24px"}}><p style={{fontSize: "16px"}}>{e.idSolicitud}</p></i>
        },
        { columna: "idMovimiento", label: "idMovimiento" },
        { columna: "po", label: "Po", splitBy:";" },
      */
    ];
    for(let c of this.props.columnas.filter(c=> {
      if(currentUser.filter(c=> c.plataforma.id === 1711).length){
        return !["ontime_cetro_carga", "ontime_salida", "ontime_cliente"].includes(c.columna);
      }else{
        return true;
      }
    })){    
       /*
          1.-Cita en centro carga (Ya está como cita en terminal) aviso 2 hras antes
          2.-Hora de máxima salida. 
          3.-Cita en cliente ( Ya creada) aviso 2 hras antes  funcionamiento en lasplataformas de monitoreo y consulta
          */
      switch (c.columna) {
        case "eventos":         
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              let eventos= [];
              for( let h of ['citaProgramadaTerminal','citaProgramada','horaMaximaSalida'] ){
                let resp= validarHorarios(e, h);
                if(resp.vencida)
                  eventos.push(                  
                    <li
                      style={{ color: resp.colorTexto, fontSize: "15px" }}
                      className="badge"
                      data-toggle="tooltip"
                      data-placement="top"
                      title= {resp.texto}
                    >
                      <i className={resp.icono}></i>
                    </li>
                  );
              }
              return  <ul style={{"list-style": 'none; padding: 0; margin: 0;'}}>
                        {eventos}
                      </ul>
            },              
            valor: (e)=>{
              let eventos= [];
              for( let h of ['citaProgramadaTerminal','citaProgramada','horaMaximaSalida'] ){
                let resp= validarHorarios(e, h);
                if(resp.vencida)
                  eventos.push( resp.texto);
              }
              return  eventos;
            }
          });
          break;
        case "contenedorTipo":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> e[c.columna] === 1? "Seco": e[c.columna] === 2? "Refrigerado": "Caja" });
          break;
        case "contenedorSize":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>
              e[c.columna] < 12?
                this.remolques[e[c.columna]]?
                  this.remolques[e[c.columna]].nombre
                  : e[c.columna]
                : e[c.columna],
            valor: (e)=> 
              e[c.columna] < 12?
                this.remolques[e[c.columna]]?
                  this.remolques[e[c.columna]].nombre
                  : e[c.columna]
                : e[c.columna]
          });
          break;
        case "estatus":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> <Form.Switch type="Checkbox" checked={e[c.columna]} /> });
          break;
        case "ontime":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( currentUser.filter(c=> c.plataforma.id === 1315 && e.idMovimientoTipo.id === 2 ).length ){
                let tiempoTemp=//2023-10-05 16:41:00- 2023-10-05 13:35:00
                  e.inicioRutaVacio !== null
                  && e.arriboDirecionCarga !== null
                  && (new Date(e.inicioRutaVacio).getTime() - new Date(e.arriboDirecionCarga).getTime()) > 0 ?
                    new Date(e.inicioRutaVacio).getTime() - new Date(e.arriboDirecionCarga).getTime()
                  :0;
                //(date_part('epoch',(m.inicio_ruta_vacio - m.arribo_direcion_carga)) * interval '1 second')::text
                return  <div className={tiempoTemp ? "status-success" : ""}>
                          {timeToTimeFull(tiempoTemp)}
                        </div>
              }else{
                return  <div className={timeToMilisegundos(e[c.columna]) ? "status-success" : ""}>
                          {e[c.columna]}
                        </div>
              }
            }
          });
          break;
        case "delay":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( currentUser.filter(c=> c.plataforma.id === 1315 && e.idMovimientoTipo.id === 2 ).length ){
                let tiempoTemp=
                  e.inicioRutaVacio !== null
                  && e.arriboDirecionCarga !== null
                  && (new Date(e.arriboDirecionCarga).getTime() - new Date(e.inicioRutaVacio).getTime()) > 0 ?
                    new Date(e.arriboDirecionCarga).getTime() - new Date(e.inicioRutaVacio).getTime()
                  :0;
                //(date_part('epoch',(m.arribo_direcion_carga - m.inicio_ruta_vacio)) * interval '1 second')::text
                return  <div className={tiempoTemp ? "status-danger" : ""}>
                          {timeToTimeFull(tiempoTemp)}
                        </div>
              }else{
                return  <div className={timeToMilisegundos(e[c.columna]) ? "status-danger" : ""}>
                          {e[c.columna]}
                        </div>
              }
            }
          });
          break;
        case "origen":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> e.idCorredor?.nombre || e.idLocalidad?.nombre || ''});
          //TODO revisar si origen destino
          // columnasTemp.push({ columna: c.columna, label: c.label,
          //   form: (e)=> [1,3].includes(e[c.columna])? e.idCorredor.nombre: e.destino });
          break;
        case "fecha_asignacion":
     
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> e.movimientosPatios[0]?.fechaCreacion});
          //TODO revisar si origen destino
          // columnasTemp.push({ columna: c.columna, label: c.label,
          //   form: (e)=> [1,3].includes(e[c.columna])? e.idCorredor.nombre: e.destino });
          break;
        case "destino":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> e.destino});
          // columnasTemp.push({ columna: c.columna, label: c.label,
          //   form: (e)=> [1,3].includes(e[c.columna])? e.destino: e.idCorredor.nombre });
          break;
        
        case "service failure":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>
              <ModalLayout
                title="Modificar"
                name={
                  <span
                    className="fa fa-bug font-120"
                    style={{
                      color: "green"
                    }}
                  />
                }
                hiddenModal={this.state.hiddenModals}
                Fclose={this.hiddenmodal}
                formulario={
                  <NavieraServiceFailure
                    accion="modificar"
                    elementos={e}
                    getfuntion={this.crud}
                    stor={this.props}
                  />
                }
              /> });
          break;
        case "full":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> e.esFull ? "full" : "sencillo" });
          break;
        case "service_order":
          if(currentUser.filter(c=> c.plataforma.id === 130).length){
            columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> e.service_order,
            valor: (e)=> e.service_order});
          }
          
        break;
        case "entrega vacio":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> {
              return e.idMovimientoTipo.id === 1 && e.salidaClienteVacio && !e.arriboTerminalVacio2 ?
                diff(
                  new Date(
                    e.salidaClienteVacio
                  ).getTime(),
                  new Date().getTime()
                )
              : e.idMovimientoTipo.id === 1 && e.salidaClienteVacio && e.arriboTerminalVacio2 ?
                diff(
                    new Date( //movimientos_terrestres_object: state.catalogos_reducer.movimientos_terrestres_object,
                      e.salidaClienteVacio
                    ).getTime(),
                    new Date(
                      e.arriboTerminalVacio2
                    ).getTime()
                  )
                : ""
            }});
          break;
        case "gps":
          columnasTemp.push({
            columna: c.columna,
            label: c.label,
            valor: (e)=> {
              let gpss= "";              
              if (e.movimientoGps && e.movimientoGps.length) {
                for( let gpsTem of e.movimientoGps ){
                    gpss= gpss + (gpss.length ? ", ":"") + gpsTem.gps.nombre;
                }
              }else{
                let mPatioTemp;
                if ( this.props.movPatio[e.id] ) {
                  mPatioTemp =
                      movsArray[ parseInt( this.props.movPatio[e.id].esFull, 10) ]
                      ? movsArray[
                          parseInt(
                            this.props.movPatio[
                              e.id
                            ].esFull,
                            10
                          )
                        ]
                      : [];
                  }
                if( mPatioTemp && mPatioTemp.movimientoGps ){
                  for( let gpsTem of mPatioTemp.movimientoGps ){
                    gpss= gpss + (gpss.length ? ", ":"") + gpsTem.gps.nombre;
                  }
                }
              }
              return gpss;
            },
            form: (elemento)=>{
              if (this.state.movsGpsEstatus) {
                let mPatioTemp;
                if (
                  this.props.movPatio[elemento.id]
                ) {
                  mPatioTemp = movsArray[
                    parseInt(
                      this.props.movPatio[elemento.id]
                        .esFull,
                      10
                    )
                  ]
                    ? movsArray[
                        parseInt(
                          this.props.movPatio[
                            elemento.id
                          ].esFull,
                          10
                        )
                      ]
                    : [];
                }
                if (elemento.movimientoGps) {
                    if (
                      elemento.movimientoGps.length
                    ) {           
                      return <Table.Col>
                          {elemento.movimientoGps.map(
                            (gpsTem, inc001) => {
                             return (
                              this.state.movsGpsEstatus[
                                gpsTem.gps.idGg
                              ]?
                                <div className="width-65px">                                  
                                  <div className="row">
                                    <div hidden={false}
                                      className="col-12 gps-battery-status"
                                      style={{
                                        color:
                                          this.state.movsGpsEstatus[
                                            gpsTem.gps.idGg
                                          ].iconBattery.color
                                      }}
                                    >
                                      {
                                        this.state.movsGpsEstatus[
                                          gpsTem.gps.idGg
                                        ].nombre
                                      }
                                    </div>
                                    <div className="col-4"> {/*  Bateria */}
                                      <div
                                        className="badge font-100"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title={
                                          this.state.movsGpsEstatus[
                                            gpsTem.gps.idGg
                                          ].nombre +
                                          ", " +
                                          this.state.movsGpsEstatus[
                                            gpsTem.gps.idGg
                                          ].nivel_bateria +
                                          " %"
                                        }
                                        style={{
                                          color:
                                            this.state.movsGpsEstatus[
                                              gpsTem.gps.idGg
                                            ].iconBattery.color
                                        }}
                                      >
                                        <span
                                          className={
                                            this.state.movsGpsEstatus[
                                              gpsTem.gps.idGg
                                            ].iconBattery.icono
                                          }
                                        ></span>
                                      </div>
                                    </div>
                                    <div className="col-4 font-100">{/*  Ultimo reporte */}
                                      <div
                                        className="badge font-100"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title={
                                          this.state.movsGpsEstatus[
                                            gpsTem.gps.idGg
                                          ].ultimo_reporte
                                        }
                                        style={{
                                          color:
                                            this.state.movsGpsEstatus[
                                              gpsTem.gps.idGg
                                            ].iconTime.color
                                        }}
                                      >
                                        <span
                                          className={
                                            this.state.movsGpsEstatus[
                                              gpsTem.gps.idGg
                                            ].iconTime.icono
                                          }
                                        ></span>
                                      </div>
                                    </div>
                                    <div className="col-4">{/*  traking */}
                                      <div
                                        className="badge badge-tracking" data-toggle="tooltip" data-placement="top" title="Tracking"
                                        onClick={() => this.tracking( elemento, gpsTem.gps) }
                                      >
                                        <span className="fa fa-map-marker float-left text-dark" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              :
                                <div>
                                  {
                                    gpsTem.gps
                                      .nombre
                                  }
                                </div>
                            )}
                          )}
                        </Table.Col>
                      
                    } else {
                    return mPatioTemp
                        ? mPatioTemp.movimientoGps
                          ? 
                              <Table.Col>
                                {mPatioTemp.movimientoGps.map(
                                  (
                                    gpsTem,
                                    inc001
                                  ) => (
                                    <div>
                                      {
                                        gpsTem.gps
                                          .nombre
                                      }
                                    </div>
                                  )
                                )}
                              </Table.Col>
                            
                          : 
                              <Table.Col></Table.Col>
                            
                        : 
                            <Table.Col></Table.Col>
                          
                    }
                  } else {        
                      return <Table.Col></Table.Col>         
                  }
              } else {
              
                return  <Table.Col>
                    {elemento.movimientoGps
                      ? elemento.movimientoGps.map(
                          (gpsTem, inc001) => (
                            <div>
                              {" "}
                              {gpsTem.gps.nombre}
                            </div>
                          )
                        )
                      : ""}
                  </Table.Col>
              
              }
            }});
          break;
        case "eta":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> {
              return this.props.etasN[e.id]
                ? this.props.etasN[e.id][2]?
                    <ModalLayout
                      tamanio={"90%"}
                      title="Etas calculadas"
                      name={
                        <div className="badge bg-secondary">
                          <Icon name="message-square" />{" "}
                          <span>
                            {
                              this.props.etasN[
                                e.id
                              ][2].total
                            }
                          </span>{" "}
                        </div>
                      }
                      hiddenModal={this.state.hiddenModals}
                      Fclose={this.hiddenmodal}
                      formulario={
                        <div>
                          <EtaCalculada
                            mov= {e}
                          />
                        </div>
                      }
                    />
                  : ""
                : ""
            }});
          break;
        case "citaProgramada":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( c.idFuncionalidad === 2891 && (e.idMovimientoTipo.id === 1 || e.idMovimientoTipo.id === 304) ){//ultima milla
                return e.citaProgramada;
              }else{
                if( c.idFuncionalidad === 2892 && (e.idMovimientoTipo.id === 2 || e.idMovimientoTipo.id === 303) ){//ultima milla
                  return e.citaProgramada;
                }
                return e.citaProgramada
              }
            },
            valor: (e)=>{
              if( c.idFuncionalidad === 2891 && (e.idMovimientoTipo.id === 1 || e.idMovimientoTipo.id === 304) ){//ultima milla
                return e.citaProgramada;
              }else{
                if( c.idFuncionalidad === 2892 && (e.idMovimientoTipo.id === 2 || e.idMovimientoTipo.id === 303) ){//ultima milla
                  return e.citaProgramada;
                }
                return e.citaProgramada
              }
            }
          });
          break;
        case "citaProgramadaTerminal_transmodal":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( c.idFuncionalidad === 2890 && (e.idMovimientoTipo.id === 1 || e.idMovimientoTipo.id === 304) ){//ultima milla
                return e.citaProgramadaTerminal;
              }else{
                if( c.idFuncionalidad === 2893 && (e.idMovimientoTipo.id === 2 || e.idMovimientoTipo.id === 303) ){//ultima milla
                  return e.citaProgramadaTerminal;
                }
                return 
              }
            },
            valor: (e)=>{
              if( c.idFuncionalidad === 2890 && (e.idMovimientoTipo.id === 1 || e.idMovimientoTipo.id === 304) ){//ultima milla
                return e.citaProgramadaTerminal;
              }else{
                if( c.idFuncionalidad === 2893 && (e.idMovimientoTipo.id === 2 || e.idMovimientoTipo.id === 303) ){//ultima milla
                  return e.citaProgramadaTerminal;
                }
                return 
              }
            }
          });
          break;
        case "consolidado_cita":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>
              e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].cita : null,
            valor: (e)=> e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].cita : null,
          });
          break;
        case "desconsolidado_cita":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>
              e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].cita : null,
            valor: (e)=> e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].cita : null,
          });
          break;
        case "contenedor_editar":
          // Solo se muestra cuando el toggle esta en "Movimientos Activos"
          if (!this.state.activos) break;
          columnasTemp.push({
            columna: c.columna,
            label: c.label,
            form: (e)=>{
              // if([1,2].includes(e.idMovimientoTipo.id) && e.contenedor && e.contenedor.length){
              //   return e.contenedor;
              // }
              return <ModalLayout
                tamanio={"50%"}
                title="Modificar"
                name={
                  <div>
                    {" "}
                    <span
                      className="fa fa-edit float-left text-success font-120"
                    />
                    <span className="float-left ml-3">
                      {e.contenedor}
                    </span>
                  </div>
                }
                hiddenModal={this.state.hiddenModals}
                Fclose={this.hiddenmodal}
                formulario={
                  <ActualizarHorariosNavieros
                    accion={"modificar"}
                    idusuario={user.id}
                    movimiento={e}
                    getfuntion={this.crud}
                    stor={this.props}
                    camposLogisticosNav={null}
                    rutasEstatusObject={
                      this.props.rutasEstatus_object
                    }
                    operacionesEstatus={
                      this.props.operacionesEstatus_object
                    }
                    closeModal={this.hiddenmodal}
                    clientes_object={
                      this.props.clientes_object
                    }
                    otd_object={this.props.otd_object}
                    currentCampo="contenedor"
                  />
                }
              />;
            },
            valor: (e)=> e.contenedor
          });
          break;
        case "sello_editar":
          // Solo se muestra cuando el toggle esta en "Movimientos Activos"
          if (!this.state.activos) break;
          columnasTemp.push({
            columna: c.columna,
            label: c.label,
            form: (e)=>{
              if([1].includes(e.idMovimientoTipo.id) && e.sello && e.sello.length){
                return e.sello;
              }
              return <ModalLayout
                tamanio={"50%"}
                title="Modificar"
                name={
                  <div>
                    <span
                      className="fa fa-edit float-left text-success font-120"
                    />
                    <span className="float-left ml-3" >
                      {e.sello}
                    </span>
                  </div>
                }
                hiddenModal={this.state.hiddenModals}
                Fclose={this.hiddenmodal}
                formulario={
                  <ActualizarHorariosNavieros
                    accion={"modificar"}
                    idusuario={user.id}
                    movimiento={e}
                    getfuntion={this.crud}
                    stor={this.props}
                    camposLogisticosNav={null}
                    rutasEstatusObject={
                      this.props.rutasEstatus_object
                    }
                    operacionesEstatus={
                      this.props.operacionesEstatus_object
                    }
                    closeModal={this.hiddenmodal}
                    clientes_object={
                      this.props.clientes_object
                    }
                    otd_object={this.props.otd_object}
                    currentCampo="sello"

                  />
                }
              />},
            valor: (e)=> e.sello
          });
          break;
        case "editar_sello_finalizados":
          // Solo se muestra cuando el toggle esta en "Movimientos Finalizados"
          if (this.state.activos) break;
          columnasTemp.push({
            columna: c.columna,
            label: c.label,
            form: (e)=> (
              <ModalLayout
                tamanio={"50%"}
                title="Modificar"
                name={
                  <div>
                    <span className="fa fa-edit float-left text-success font-120" />
                    <span className="float-left ml-3">{e.sello}</span>
                  </div>
                }
                hiddenModal={this.state.hiddenModals}
                Fclose={this.hiddenmodal}
                formulario={
                  <ActualizarHorariosNavieros
                    accion={"modificar"}
                    idusuario={user.id}
                    movimiento={e}
                    getfuntion={this.crud}
                    stor={this.props}
                    camposLogisticosNav={null}
                    rutasEstatusObject={this.props.rutasEstatus_object}
                    operacionesEstatus={this.props.operacionesEstatus_object}
                    closeModal={this.hiddenmodal}
                    clientes_object={this.props.clientes_object}
                    otd_object={this.props.otd_object}
                    currentCampo="sello"
                  />
                }
              />
            ),
            valor: (e)=> e.sello
          });
          break;
        case "editar_contenedor_finalizados":
          // Solo se muestra cuando el toggle esta en "Movimientos Finalizados"
          if (this.state.activos) break;
          columnasTemp.push({
            columna: c.columna,
            label: c.label,
            form: (e)=> (
              <ModalLayout
                tamanio={"50%"}
                title="Modificar"
                name={
                  <div>
                    <span className="fa fa-edit float-left text-success font-120" />
                    <span className="float-left ml-3">{e.contenedor}</span>
                  </div>
                }
                hiddenModal={this.state.hiddenModals}
                Fclose={this.hiddenmodal}
                formulario={
                  <ActualizarHorariosNavieros
                    accion={"modificar"}
                    idusuario={user.id}
                    movimiento={e}
                    getfuntion={this.crud}
                    stor={this.props}
                    camposLogisticosNav={null}
                    rutasEstatusObject={this.props.rutasEstatus_object}
                    operacionesEstatus={this.props.operacionesEstatus_object}
                    closeModal={this.hiddenmodal}
                    clientes_object={this.props.clientes_object}
                    otd_object={this.props.otd_object}
                    currentCampo="contenedor"
                  />
                }
              />
            ),
            valor: (e)=> e.contenedor
          });
          break;
        case "so_editar":
          columnasTemp.push({
            columna: c.columna,
            label: c.label,
            form: (e)=>{
              // if([1,2].includes(e.idMovimientoTipo.id) && e.contenedor && e.contenedor.length){
              //   return e.contenedor;
              // }
              return <ModalLayout
                tamanio={"50%"}
                title="Modificar"
                name={
                  <div>
                    {" "}
                    <span
                      className="fa fa-edit float-left text-success font-120"
                    />
                    <span className="float-left ml-3">
                      {e.service_order}
                    </span>
                  </div>
                }
                hiddenModal={this.state.hiddenModals}
                Fclose={this.hiddenmodal}
                formulario={
                  <ActualizarHorariosNavieros
                    accion={"modificar"}
                    idusuario={user.id}
                    movimiento={e}
                    getfuntion={this.crud}
                    stor={this.props}
                    camposLogisticosNav={null}
                    rutasEstatusObject={
                      this.props.rutasEstatus_object
                    }
                    operacionesEstatus={
                      this.props.operacionesEstatus_object
                    }
                    closeModal={this.hiddenmodal}
                    clientes_object={
                      this.props.clientes_object
                    }
                    otd_object={this.props.otd_object}
                    currentCampo="serviceOrder"
                  />
                }
              />;
            },
            valor: (e)=> e.service_order
          });
          break;
        case "onTimePickUp"://cita-fechaArribo
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( e.idMovimientoTipo.id === 1 || e.idMovimientoTipo.id === 304 ){//ultima milla
                //return milisecondsToHours( e.citaProgramada, e.arriboTerminalVacio)
                return milisecondsToHours( e.citaProgramadaTerminal, e.arriboTerminalVacio)
              }
              if( e.idMovimientoTipo.id === 2 ){//primera milla
                return milisecondsToHours( e.citaProgramada, e.arriboDirecionCarga)
              }
              if( e.idMovimientoTipo.id === 270 ){
                if (e.entregas.length != 0) {//consolidacion
                  return milisecondsToHours(
                    e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].cita,
                    e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].fechaArribo
                  )
                }
                return "S/I";
              }
            },
            valor: (e)=>{
              if( e.idMovimientoTipo.id === 1 || e.idMovimientoTipo.id === 304 ){
                return milisecondsToHours( e.citaProgramada, e.arriboTerminalVacio)
              }
              if( e.idMovimientoTipo.id === 2 ){
                return milisecondsToHours( e.citaProgramada, e.arriboDirecionCarga)
              }
              if( e.idMovimientoTipo.id === 270 ){
                if (e.entregas.length != 0) {
                  return milisecondsToHours(
                    e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].cita,
                    e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].fechaArribo
                  )
                }
                return "S/I";
              }
            }
          });
          break;
        case "onTimeDelivery"://importacin: citaProgramada-arriboCliente, distribución: e.cita-e.fechaArribo
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( e.idMovimientoTipo.id === 1 ){
                return milisecondsToHours(e.citaProgramada, e.arriboClienteLleno)
              }
              if( e.idMovimientoTipo.id === 2 ){
                return "S/I";
              }
              if( e.idMovimientoTipo.id === 270 ){
                if (e.entregas.length != 0) {
                  return milisecondsToHours(
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].cita,
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaArribo
                  )
                }
                return "S/I";
              }
            },
            valor: (e)=>{
              if( e.idMovimientoTipo.id === 1 ){
                return milisecondsToHours(e.citaProgramada, e.arriboClienteLleno)
              }
              if( e.idMovimientoTipo.id === 2 ){
                return "S/I";
              }
              if( e.idMovimientoTipo.id === 270 ){
                if (e.entregas.length != 0) {
                  return milisecondsToHours(
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].cita,
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaArribo
                  )
                }
                return "S/I";
              }
            }
          });
          break;
        case "tiempoDescarga"://importacin: arriboClienteLleno-salidaClieneVacio, distribución: e.fechaArribo-fechaSalida
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( e.idMovimientoTipo.id === 1 ){
                return milisecondsToHours(e.salidaClienteVacio, e.arriboClienteLleno)
              }
              if( e.idMovimientoTipo.id === 2 ){
                return "S/I";
              }
              if( e.idMovimientoTipo.id === 270 ){
                if (e.entregas.length != 0) {
                  return milisecondsToHours(
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaSalida,
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaArribo
                  )
                }
                return "S/I";
              }
            },
            valor: (e)=>{
              if( e.idMovimientoTipo.id === 1 ){
                return milisecondsToHours(e.salidaClienteVacio, e.arriboClienteLleno)
              }
              if( e.idMovimientoTipo.id === 2 ){
                return "S/I";
              }
              if( e.idMovimientoTipo.id === 270 ){
                if (e.entregas.length != 0) {
                  return milisecondsToHours(
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaSalida,
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaArribo
                  )
                }
                return "S/I";
              }
            }
          });
          break;
        case "consolidado_arribo":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>
              e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].fechaArribo : null,
            valor: (e)=> e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].fechaArribo : null,
          });
          break;
        case "desconsolidado_arribo":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>
              e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaArribo : null,
            valor: (e)=> e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaArribo : null,
          });
          break;
        case "desconsolidado_salida":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>
              e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaSalida : null,
            valor: (e)=> e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaSalida : null
          });
          break;
        case "operador":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>  {
              return e.movimientosPatios.length > 0  ? e.movimientosPatios[0].operadorNombre : ""
            }
          });
        break;
        case "transporte":
          columnasTemp.push({ columna: c.columna, label: c.label,
            enClick: (e)=>{
              this.setState({patio: {}, patioFull: {}, tractoActualObj: null, remolqueActualObj: null, remolqueFullActualObj: null, gpsFijoNombre: null, gpsFijoFullNombre: null, movimientoTransporteActual: e});
              Crud_Catalogos("movimientosPatio/idMovimiento/"+e.id,"","get","",[],"","","",[]).then((returnVal)=>{                                                
                this.setState({patio: returnVal});
                // Buscar tracto completo por placa
                if (returnVal.tractorPlaca && e.idTransportista?.id) {
                  Crud_Catalogos("unidadTerNav/idTransportista/" + e.idTransportista.id, "", "get", "", [], "", "", "", [])
                    .then((tractos) => {
                      const tractoEncontrado = tractos.find(t => t.placa && t.placa.toLowerCase() === returnVal.tractorPlaca.toLowerCase());
                      if (tractoEncontrado) {
                        this.setState({ tractoActualObj: tractoEncontrado });
                      }
                    })
                    .catch(err => console.error("Error buscando tracto:", err));
                }
                // Buscar remolque completo por placa
                if (returnVal.remolquePlaca) {
                  Crud_Catalogos("remolques", "", "get", "", [], "", "", "", [])
                    .then((remolques) => {
                      const remolqueEncontrado = remolques.find(r => r.placa && r.placa.toLowerCase() === returnVal.remolquePlaca.toLowerCase());
                      if (remolqueEncontrado) {
                        this.setState({ remolqueActualObj: remolqueEncontrado });
                      }
                    })
                    .catch(err => console.error("Error buscando remolque:", err));
                  // Buscar GPS fijo vinculado al remolque (por placa)
                  Crud_Catalogos("remolquesGpsFijos/placa/" + encodeURIComponent(returnVal.remolquePlaca) + "/activo", "", "get", "", [], "", "", "", [])
                    .then((vinc) => {
                      this.setState({ gpsFijoNombre: (vinc && vinc.gps) ? vinc.gps.nombre : null });
                    })
                    .catch(() => this.setState({ gpsFijoNombre: null }));
                }
                // Si el movimiento tiene un full, buscar el patio del movimiento full y su remolque
                const esFull = e.movimientosPatios && e.movimientosPatios.length > 0 ? e.movimientosPatios[0].esFull : null;
                if (esFull && esFull !== "") {
                  Crud_Catalogos("movimientosPatio/idMovimiento/" + esFull, "", "get", "", [], "", "", "", [])
                    .then((patioFull) => {
                      this.setState({ patioFull: patioFull });
                      // Buscar remolque full completo por placa
                      if (patioFull.remolquePlaca) {
                        Crud_Catalogos("remolques", "", "get", "", [], "", "", "", [])
                          .then((remolques) => {
                            const remFullEncontrado = remolques.find(r => r.placa && r.placa.toLowerCase() === patioFull.remolquePlaca.toLowerCase());
                            if (remFullEncontrado) {
                              this.setState({ remolqueFullActualObj: remFullEncontrado });
                            }
                          })
                          .catch(err => console.error("Error buscando remolque full:", err));
                        // Buscar GPS fijo vinculado al remolque full (por placa)
                        Crud_Catalogos("remolquesGpsFijos/placa/" + encodeURIComponent(patioFull.remolquePlaca) + "/activo", "", "get", "", [], "", "", "", [])
                          .then((vinc) => {
                            this.setState({ gpsFijoFullNombre: (vinc && vinc.gps) ? vinc.gps.nombre : null });
                          })
                          .catch(() => this.setState({ gpsFijoFullNombre: null }));
                      }
                    })
                    .catch(err => console.error("Error buscando patio full:", err));
                }
              }).catch(err =>{ console.log(err);});
            },
            enClickDisabled: false,
            form: (e)=>
            <ModalLayout tamanio={'80%'} title="Movimiento"
              name={<span><Icon prefix="fa" name="bullhorn" /></span>}
              hiddenModal={this.state.hiddenModals} Fclose={this.hiddenmodal}
              formulario={//999022
                <div>
                  <List.Group>
                    <List.GroupItem action icon="truck"> Transportista:   <strong> { e['idTransportista']? e['idTransportista'].nombre:""} </strong> </List.GroupItem>
                    <List.GroupItem action icon="user"> Operador:         <strong> { this.state.patio.operadorNombre? this.state.patio.operadorNombre:"" } </strong> </List.GroupItem>
                    <List.GroupItem action icon="phone"> Contacto:         <strong> { this.state.patio.operadorContacto? this.state.patio.operadorContacto:"" } </strong> </List.GroupItem>
                    <List.GroupItem action icon="truck"> Tracto:          <strong> { this.state.patio.tractorPlaca? this.state.patio.tractorPlaca: ""           } </strong> </List.GroupItem>                  
                    <List.GroupItem action icon="pocket"> Marca:          <strong> { this.state.patio.tractorMarca? this.state.patio.tractorMarca:""  } </strong> </List.GroupItem>
                    <List.GroupItem action icon="circle"> Color:          <strong> { this.state.patio.tractorColor? this.state.patio.tractorColor: ""           } </strong> </List.GroupItem>
                    <List.GroupItem action icon="underline"> Económico Tracto: <strong> { this.state.patio.economicot? this.state.patio.economicot: ""  } </strong> </List.GroupItem>
                    <List.GroupItem action icon="truck"> Remolque:        <strong> { this.state.patio.remolquePlaca? this.state.patio.remolquePlaca: ""  } </strong> </List.GroupItem>
                    <List.GroupItem action icon="underline"> Económico Remolque: <strong> { this.state.patio.economicor? this.state.patio.economicor: ""  } </strong> </List.GroupItem>
                    <List.GroupItem action icon="map-pin"> GPS: <strong> { this.state.gpsFijoNombre? this.state.gpsFijoNombre: "-"  } </strong> </List.GroupItem>
                    {(e.movimientosPatios && e.movimientosPatios.length > 0 && e.movimientosPatios[0].esFull && e.movimientosPatios[0].esFull !== "") && (
                      <>
                        <List.GroupItem action icon="truck"> Remolque Full:   <strong> { this.state.patioFull.remolquePlaca? this.state.patioFull.remolquePlaca: ""  } </strong> </List.GroupItem>
                        <List.GroupItem action icon="underline"> Económico Remolque Full: <strong> { this.state.patioFull.economicor? this.state.patioFull.economicor: ""  } </strong> </List.GroupItem>
                        <List.GroupItem action icon="map-pin"> GPS Full: <strong> { this.state.gpsFijoFullNombre? this.state.gpsFijoFullNombre: "-"  } </strong> </List.GroupItem>
                      </>
                    )}
                  </List.Group>

                  {/* Botones de acción */}
                  <div style={{ display: 'flex', gap: '8px', marginTop: '16px', flexWrap: 'wrap' }}>

                    {/* Botón: Nuevo Operador */}
                    <ModalLay
                      tamanio="80%"
                      title="Nuevo Operador"
                      name={
                        <Button size="sm" color="success">
                          <Icon name="user-plus" /> Nuevo Operador
                        </Button>
                      }
                      hiddenModal={this.state.modalNuevoOperador}
                      Fclose={() => { this.setState({ modalNuevoOperador: false }); this.recargarDatosPatio(); }}
                      formulario={OperadoresForm}
                      datosForm={{
                        accion: "nuevo",
                        elementos: null,
                        getfuntion: Crud_Catalogos,
                        stor: {},
                        idTransportista: this.state.idTransportista,
                      }}
                    />

                    {/* Botón: Editar Operador */}
                    <ModalLay
                      tamanio="80%"
                      title="Editar Operador"
                      name={
                        <Button size="sm" color="primary">
                          <Icon name="edit" /> Editar Operador
                        </Button>
                      }
                      hiddenModal={this.state.modalEditarOperador}
                      Fclose={() => { this.setState({ modalEditarOperador: false }); this.recargarDatosPatio(); }}
                      formulario={OperadoresForm}
                      datosForm={{
                        accion: "editar",
                        elementos: this.state.patio,
                        getfuntion: Crud_Catalogos,
                        stor: {},
                        idTransportista: this.state.idTransportista,
                      }}
                    />

                    {/* Botón: Editar Tracto */}
                    <ModalLay
                      tamanio="70%"
                      title="Editar Tracto"
                      name={
                        <Button size="sm" color="warning">
                          <Icon name="truck" /> Editar Tracto
                        </Button>
                      }
                      hiddenModal={this.state.modalEditarTracto}
                      Fclose={() => { this.setState({ modalEditarTracto: false }); this.recargarDatosPatio(); }}
                      formulario={TractosForm}
                      datosForm={{
                        accion: "editar",
                        elementos: this.state.tractoActualObj ? {
                          id: this.state.tractoActualObj.id,
                          placa: this.state.tractoActualObj.placa || this.state.patio.tractorPlaca,
                          economico: this.state.tractoActualObj.economico || this.state.patio.economicot,
                          idUnidadMarca: this.state.tractoActualObj.idUnidadMarca || null,
                          color: this.state.tractoActualObj.color || this.state.patio.tractorColor || "",
                          modelo: this.state.tractoActualObj.modelo || "",
                        } : (this.state.patio.tractorPlaca ? {
                          placa: this.state.patio.tractorPlaca,
                          economico: this.state.patio.economicot,
                        } : null),
                        idTransportista: this.state.idTransportista,
                      }}
                    />

                    {/* Botón: Editar Remolque */}
                    <ModalLay
                      tamanio="60%"
                      title="Editar Remolque"
                      name={
                        <Button size="sm" color="secondary">
                          <Icon name="package" /> Editar Remolque
                        </Button>
                      }
                      hiddenModal={this.state.modalEditarRemolque}
                      Fclose={() => { this.setState({ modalEditarRemolque: false }); this.recargarDatosPatio(); }}
                      formulario={RemolquesForm}
                      datosForm={{
                        accion: "editar",
                        elementos: this.state.remolqueActualObj ? {
                          idRemolque: this.state.remolqueActualObj.idRemolque,
                          placa: this.state.remolqueActualObj.placa || this.state.patio.remolquePlaca,
                          economico: this.state.remolqueActualObj.economico || this.state.patio.economicor,
                          remolquesTipos: this.state.remolqueActualObj.remolquesTipos || null,
                        } : (this.state.patio.remolquePlaca ? {
                          placa: this.state.patio.remolquePlaca,
                          economico: this.state.patio.economicor,
                        } : null),
                        idTransportista: this.state.idTransportista,
                      }}
                    />

                    {/* Botón: Editar Remolque Full (solo si hay full) */}
                    {(e.movimientosPatios && e.movimientosPatios.length > 0 && e.movimientosPatios[0].esFull && e.movimientosPatios[0].esFull !== "") && (
                      <ModalLay
                        tamanio="60%"
                        title="Editar Remolque Full"
                        name={
                          <Button size="sm" color="info">
                            <Icon name="package" /> Editar Remolque Full
                          </Button>
                        }
                        hiddenModal={false}
                        Fclose={() => { this.recargarDatosPatio(); }}
                        formulario={RemolquesForm}
                        datosForm={{
                          accion: "editar",
                          elementos: this.state.remolqueFullActualObj ? {
                            idRemolque: this.state.remolqueFullActualObj.idRemolque,
                            placa: this.state.remolqueFullActualObj.placa || this.state.patioFull.remolquePlaca,
                            economico: this.state.remolqueFullActualObj.economico || this.state.patioFull.economicor,
                            remolquesTipos: this.state.remolqueFullActualObj.remolquesTipos || null,
                          } : (this.state.patioFull.remolquePlaca ? {
                            placa: this.state.patioFull.remolquePlaca,
                            economico: this.state.patioFull.economicor,
                          } : null),
                          idTransportista: this.state.idTransportista,
                        }}
                      />
                    )}

                  </div>
                </div>
            }
          />
          }
            );
          break;
        case "otd":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if(timeToMilisegundos(e['ontime']) > 0){
                return "En tiempo"
              }
              if(timeToMilisegundos(e['delay']) > 0){
                return "Tarde"
              }
            },
            valor: (e)=> e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].fechaArribo : null,
          });
          break;
        case "registroOperador":
            columnasTemp.push({ columna: c.columna, label: c.label,
              form: (e)=>{
                return <ModalLayout 
                  tamanio={'80%'} 
                  title="Movimiento"
                  name={<span
                      className="fa fa-edit float-left text-success font-120"
                    />}
                  hiddenModal={this.state.hiddenModals} 
                  Fclose={this.hiddenmodal}
                  formulario={
                    <OperadoresNavieros
                        data = {e}
                        accion="modificar"
                        usuario={user}
                        getfuntion={this.getfuntion}
                        stor={this.props}
                        elementos= {this.state.elementosSinfiltrar}
                        closeModal={this.hiddenmodal}
                        readonly={this.state.readonly || !this.state.activos}
                        updateData = {this.updateData}
                     />  
                  }
                />
              },
            });
            break;
            case "lineaTiempo":
              { 
            columnasTemp.push({ columna: c.columna, label: c.label,
              form: (e)=>{
                
                return <ModalLayout 
                  tamanio={'80%'} 
                  title="WTI"
                  name={<div class="timeline-icon-glow">
                      <div class="main-line"></div>
                      <div class="glow-dot"></div>
                      <div class="glow-dot"></div>
                      <div class="glow-dot"></div>
                  </div>}
                  hiddenModal={this.state.hiddenModals} 
                  Fclose={this.hiddenmodal}
                  formulario={
                    <TimelineComponent
                        movimiento = {e}
                        accion="modificar"
                        usuario={user}
                        getfuntion={this.getfuntion}
                        closeModal={this.hiddenmodal}
                        readonly={this.state.readonly}
                        updateData = {this.updateData}
                     />  
                  }
                />
              },
            })
            }
            break;
            case "remolquePlaca":
              columnasTemp.push({ columna: c.columna, label: c.label,
                form: (e)=>
                  e.movimientosPatios.length > 0 ? e.movimientosPatios[0].remolquePlaca: null
              });
            break;

            case "economicor":
              columnasTemp.push({ columna: c.columna, label: c.label,
                form: (e)=>
                  e.movimientosPatios.length > 0 ? e.movimientosPatios[0].economicor: null
              });
            break;

            case "operadorNombre":
              columnasTemp.push({ columna: c.columna, label: c.label,
                form: (e)=>
                  e.movimientosPatios.length > 0 ? e.movimientosPatios[0].operadorNombre: null
              });
            break;

            case "tractorPlaca":
              columnasTemp.push({ columna: c.columna, label: c.label,
                form: (e)=>
                  e.movimientosPatios.length > 0 ? e.movimientosPatios[0].tractorPlaca: null
              });
            break;

            case "operadorContacto":
              columnasTemp.push({ columna: c.columna, label: c.label,
                form: (e)=>
                  e.movimientosPatios.length > 0 ? e.movimientosPatios[0].operadorContacto: null
              });
            break;
             case "po":
                  
                  if(currentUser.filter(c=> c.plataforma.id === 1711).length){
                    columnasTemp.push({ columna: c.columna, label: 'LOAD',
                    form: (e)=> (e.variables?.load),
                    valor:(e)=> (e.variables?.load)});
                  }else{
                    columnasTemp.push({ columna: c.columna, label: c.label,
                    form: (e)=> e.po,
                    valor:(e)=> (e.po)});
                  }
                

            break;
            
            ////18722103, 18720638, 18724895
            case "variables.cuenta_espejo":
              columnasTemp.push({ columna: c.columna, label: c.label,
                form: (e)=>{
                  if( e.variables && e.variables.cuenta_espejo && e.variables.cuenta_espejo.url ){//mostrar cuenta espejo
                    return <ModalLayout
                      tamanio={this.tamanio}
                      title={"Cuenta espejo "+ e.id}
                      name={
                        <span className="badge"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Ver credenciales de cuenta espejo"
                          style={{fontSize: '20px'}}>
                          🔐
                        </span>}
                      hiddenModal={this.state.hiddenModals}
                      Fclose={this.hiddenmodal}
                      formulario={
                        <CuentaEspejo
                          cuenta_espejo={
                            e.variables?.cuenta_espejo||{}} />
                      }
                    />
                  }else{//Se toma como no hay cuenta espejo y se procede a mostrar tracking
                    //18724050
                    if(e.movimientoGps && e.movimientoGps[0]){
                      return <div
                                className="badge badge-tracking" data-toggle="tooltip" data-placement="top" title="Tracking"
                                onClick={() => this.tracking( e, e.movimientoGps[0].gps) }
                              >
                                <span className="fa fa-map-marker float-left" style={{fontSize: '20px', color: 'blue'}}/>
                              </div>
                    }
                  }
                  return "";
                },
              });
            break;
            case "variables.reutilizar":
              columnasTemp.push({ columna: c.columna, label: c.label,
                form: (e)=>{
                  return <ModalLayout
                    tamanio={"50%"}
                    title="Reutilizar"
                    name={
                      <div>
                        <span
                          className="fa fa-edit float-left text-success font-120"
                        />
                        <span className="float-left ml-3">
                          {e.variables && e.variables.reutilizar === true ? "Reutiliza" : "No reutiliza"}
                        </span>
                      </div>
                    }
                    hiddenModal={this.state.hiddenModals}
                    Fclose={this.hiddenmodal}
                    formulario={
                      <ActualizarHorariosNavieros
                        accion={"modificar"}
                        idusuario={user.id}
                        movimiento={e}
                        getfuntion={this.crud}
                        stor={this.props}
                        camposLogisticosNav={null}
                        rutasEstatusObject={
                          this.props.rutasEstatus_object
                        }
                        operacionesEstatus={
                          this.props.operacionesEstatus_object
                        }
                        closeModal={this.hiddenmodal}
                        clientes_object={
                          this.props.clientes_object
                        }
                        otd_object={this.props.otd_object}
                        currentCampo="reutilizar"
                      />
                    }
                  />;
                },
                valor: (e)=> e.variables && e.variables.reutilizar === true ? "Sí reutiliza" : "No reutiliza"
              });
            break;
            /*
            ['citaProgramadaTerminal','citaProgramada','horaMaximaSalida'] ){
                let resp= validarHorarios(e, h);
             */
        case "ontime_cetro_carga"://arribo centro de carga: citaProgramadaTerminal-arriboDireccionCarga
          columnasTemp.push({
            columna: c.columna,
            label: c.label,
            form: (e)=> onTime(e, 'citaProgramadaTerminal'),
            valor: (e)=>onTime(e, 'citaProgramadaTerminal')
          });
        break;
        case "ontime_salida"://salida centro de carga: horaMaximaSalida-inicioRuta
          columnasTemp.push({
            columna: c.columna,
            label: c.label,
            form: (e)=> onTime(e, 'horaMaximaSalida'),
            valor: (e)=>onTime(e, 'horaMaximaSalida')
          });
        break;
        case "ontime_cliente"://arribo en cliente: citaProgramada - e.arriboClienteLleno
          columnasTemp.push({
            columna: c.columna,
            label: c.label,
            form: (e)=> onTime(e, 'citaProgramada'),
            valor: (e)=>onTime(e, 'citaProgramada')
          });
        break;
        default: columnasTemp.push({ columna: c.columna, label: c.label });
          break;
      }
    }
    if (puedeVerHistorial) {
      columnasTemp.push({
        columna: "_historial",
        label: "Historial",
        form: (e) => (
          <ModalLay
            tamanio="70%"
            title="Historial de Cambios"
            name={
              <span
                title="Ver historial"
                style={{ color: '#6c757d', fontSize: '14px', cursor: 'pointer' }}
              >
                <Icon prefix="fa" name="history" />
              </span>
            }
            formulario={HistorialMovimiento}
            datosForm={{ idMovimiento: e.id }}
          />
        ),
      });
    }
    columnasTemp.push({
      columna: "_ruteador",
      label: "Ruta",
      form: (e) => (
        <span
          onClick={(ev) => {
            ev.stopPropagation();
            const origenNombre = e.idCorredor ? e.idCorredor.nombre : '';
            const origenCoords = e.idCorredor && e.idCorredor.latitud && e.idCorredor.longitud ? [e.idCorredor.latitud, e.idCorredor.longitud] : null;
            this.setState({ ruteadorModal: { movId: e.id, origen: origenNombre, origenCoords, destino: e.destino || '', gpsIds: e.movimientoGps ? e.movimientoGps.map((g) => g.gps.idGg) : [] } });
          }}
          title="Ver ruta"
          style={{ color: '#2563eb', fontSize: '14px', cursor: 'pointer' }}
        >
          🗺️
        </span>
      ),
    });

    // Reordena contenedor y sello para que queden juntos en las posiciones 6 y 7.
    // Contenedor puede venir como "contenedor_editar" (activos) o
    // "editar_contenedor_finalizados" (finalizados). Sello siempre es "sello_editar".
    // Se actua sobre el array ya construido para respetar el resto del orden.
    const contenedorCols = ["contenedor_editar", "editar_contenedor_finalizados"];
    const selloCol = "sello_editar";
    const contenedorItem = columnasTemp.find((col) => contenedorCols.includes(col.columna));
    const selloItem = columnasTemp.find((col) => col.columna === selloCol);
    if (contenedorItem && selloItem) {
      // Quitamos ambas columnas de su posicion actual
      columnasTemp = columnasTemp.filter(
        (col) => col !== contenedorItem && col !== selloItem
      );
      // Reinsertamos en indice 5 (posicion 6) y 6 (posicion 7)
      const posicion = Math.min(5, columnasTemp.length);
      columnasTemp.splice(posicion, 0, contenedorItem, selloItem);
    }

    return columnasTemp;
  }
  table_headers = (asc) => {
    this.content = [];
    Object.keys(this.props.columnas).forEach((key, index) => {
      this.content.push({
        content: (
          <div
            onClick={() => {
              this.sortElements(this.props.columnas[index].nombre);
            }}
          >
            {this.props.columnas[index].nombre}
            {this.colToFilter === this.props.columnas[index].nombre ? (
              <Icon name={asc ? "chevron-up" : "chevron-down"} />
            ) : null}
          </div>
        ),
      });
    });
    this.setState({ tableheaderItems: this.content });
  };
  /**
   * 
   * @param {*} asc 
   */
  table_headers_incidencias = (asc, col= this.state.incidenciaColumna.col) => {
    const columsTemp=[
      { col:"fechaCreado", label: "Fecha" },
      { col:"incidencia", label: "Incidencia" },
      { col:"comentario", label: "Comentario" }
    ];
    let columnaTemp=[];
    for(let c of columsTemp){//incidenciaColumna: {col: "fechaCreado", Desc: true},
      columnaTemp.push({
        content: (
          <div  onClick={() =>  this.sortIncidencias(c.col) } >
            { c.label }
            { col === c.col ? ( <Icon name={asc ? "chevron-down":"chevron-up"} />) : null}
          </div>
        ),
      });
    }
    this.setState({ incidenciatableheader: columnaTemp });
  };


  table_headers_bitacora = (asc, col= this.state.incidenciaColumna.col) => {
    const columsTemp=[
      { col:"idBitacoraMonitoreo", label: "Evento" },
      { col:"descripcion", label: "Detalle" },
      { col:"idUsuario", label: "N0mbre Usuario" },
      { col:"accionFecha", label: "Fecha" }
    ];
    let columnaTemp=[];
    for(let c of columsTemp){//incidenciaColumna: {col: "fechaCreado", Desc: true},
      columnaTemp.push({
        content: (
          <div  onClick={() =>  this.sortIncidencias(c.col) } >
            { c.label }
            { col === c.col ? ( <Icon name={asc ? "chevron-down":"chevron-up"} />) : null}
          </div>
        ),
      });
    }
    this.setState({ bitacoratableheader: columnaTemp });
  };
  sortIncidencias = (columna= this.state.incidenciaColumna.col) => {
    let oldCol = this.state.incidenciaColumna.col;
    let AscDescTemp= this.state.incidenciaColumna.Desc;
    if (oldCol === columna) {
      AscDescTemp = !AscDescTemp;
    } else {
      AscDescTemp = true;
    }

    this.setState({ incidenciaColumna: {col: columna, Desc: AscDescTemp} });
    if (oldCol === columna) {
      this.table_headers_incidencias( AscDescTemp, columna );
    } else {
      this.table_headers_incidencias(true, columna);
    }

    var originalArray = [...this.state.incidencias];
    if (!originalArray[0]) return;

    if (AscDescTemp) {
      if (typeof originalArray[0][columna] == "object") {
        originalArray = originalArray.sort(function(a, b) {
          if (a[columna] === null || b[columna] === null) {
            return -1;
          } // si es nulo lo ordena al final
          if (a[columna].nombre < b[columna].nombre) {
            return 1;
          }
          if (a[columna].nombre > b[columna].nombre) {
            return -1;
          }
          return 0;
        });
      } else {
        originalArray = originalArray.sort(function(a, b) {
          if (a[columna] < b[columna]) {
            return 1;
          }
          if (a[columna] > b[columna]) {
            return -1;
          }
          return 0;
        });
      }
      //return a[columna]-b[columna] }); //Asecendente
    } else {
      if (typeof originalArray[0][columna] == "object") {
        originalArray = originalArray.sort(function(a, b) {
          if (a[columna] === null || b[columna] === null) {
            return 1;
          } // si es nulo lo ordena al final
          if (a[columna].nombre > b[columna].nombre) {
            return 1;
          }
          if (a[columna].nombre < b[columna].nombre) {
            return -1;
          }
          return 0;
        });
      } else {
        originalArray = originalArray.sort(function(a, b) {
          if (a[columna] > b[columna]) {
            return 1;
          }
          if (a[columna] < b[columna]) {
            return -1;
          }
          return 0;
        });
      }
    }
    this.setState({ incidencias: originalArray });
  }
/**
 * 
 * @param {*} columna 
 * @returns 
 */
  sortElements = (columna) => {
    let oldCol = this.colToFilter;
    if (this.colToFilter === columna) {
      this.AscDesc = !this.AscDesc;
    } else {
      this.AscDesc = true;
    }
    this.colToFilter = columna;
    this.setState({ colToFilter: columna });
    if (oldCol === columna) {
      this.table_headers(this.AscDesc);
    } else {
      this.table_headers(true);
    }

    var originalArray = this.state.elementos;
    if (!originalArray[0]) {
      return;
    }
    if (this.AscDesc) {
      if (typeof originalArray[0][columna] == "object") {
        originalArray = originalArray.sort(function(a, b) {
          if (a[columna] === null || b[columna] === null) {
            return -1;
          } // si es nulo lo ordena al final
          if (a[columna].nombre > b[columna].nombre) {
            return 1;
          }
          if (a[columna].nombre < b[columna].nombre) {
            return -1;
          }
          return 0;
        });
      } else {
        originalArray = originalArray.sort(function(a, b) {
          if (a[columna] > b[columna]) {
            return 1;
          }
          if (a[columna] < b[columna]) {
            return -1;
          }
          return 0;
        });
      }
      //return a[columna]-b[columna] }); //Asecendente
    } else {
      if (typeof originalArray[0][columna] == "object") {
        originalArray = originalArray.sort(function(a, b) {
          if (a[columna] === null || b[columna] === null) {
            return 1;
          } // si es nulo lo ordena al final
          if (a[columna].nombre < b[columna].nombre) {
            return 1;
          }
          if (a[columna].nombre > b[columna].nombre) {
            return -1;
          }
          return 0;
        });
      } else {
        originalArray = originalArray.sort(function(a, b) {
          if (a[columna] < b[columna]) {
            return 1;
          }
          if (a[columna] > b[columna]) {
            return -1;
          }
          return 0;
        });
      }
      //return b[columna]-a[columna] }); //Descendente
    }
    this.setState({ elementos: originalArray });
  }
  ;
  isobject = () => {
    if (typeof this.columna === "object") {
      if (this.columna.length > 1) {
        for (let item of this.columna) {
          this.colum.push(
            <Table.Col>
              {
                <ModalLayout
                  tamanio={this.tamanio}
                  title="Modificar"
                  name={item["nombre"] + " ..."}
                  hiddenModal={this.state.hiddenModals}
                  Fclose={this.hiddenmodal}
                  formulario={
                    <this.Catalogo_form
                      accion="modificar"
                      elementos={this.fila}
                      getfuntion={this.getfuntion}
                      stor={this.props}
                    />
                  }
                />
              }
            </Table.Col>



          );
          break;
        }
      } else {
        switch (this.campo) {
          case "username":
            this.colum.push(<Table.Col>{this.columna["username"]}</Table.Col>);
            break;
          case "idOtd":
            this.colum.push(
              <Table.Col>
                {timeToMilisegundos(this.registro.delay) > 0 ? (
                  <div
                    className="badge bg-secondary"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={this.columna["nombre"]}
                  >
                    <Icon name="message-square" />
                  </div>
                ) : (
                  ""
                )}
              </Table.Col>
            );
            break;

          default:
            this.colum.push(<Table.Col>{this.columna["nombre"]}</Table.Col>);
            break;
        }
      }
    }
  };

  changePlataformas = (event) => {
  
    this.setState({cambioPlataforma: true });
    this.setState({plataforma: event });
    this.setState({localidades:[]})
    this.setState({elementos:this.state.elementosSinfiltrar})
    this.update_localidades(event);
    // this.updateAlertas(this.state.listaAlertasSinFiltrar, event.value);

    // Recalcular idTransportista según la plataforma seleccionada
    if (event.value && event.value > 0 && user) {
      Crud_Catalogos(
        "usuarios_transportistas/usuario/" + user.id + "/plataforma/" + event.value,
        "", "get", "", [], "", "", "", []
      ).then((transportistas) => {
        if (transportistas && transportistas.length > 0) {
          const valido = transportistas.find(t => t.idTransportista !== null);
          this.setState({ idTransportista: valido ? valido.idTransportista : null });
        } else {
          this.setState({ idTransportista: null });
        }
      }).catch(err => {
        console.error("Error al obtener transportista por plataforma:", err);
      });
    } else {
      // "Todas" seleccionado - mantener el idTransportista existente
    }
  };
  objectFilter = (columna) => {
    if (columna) {
      if (columna.nombre) {
        return columna.nombre;
      } else {
        return columna;
      }
    } else {
      return "";
    }
  };
  getFuncionalidad = (elemento) => {
    if (this.state.elementos.length > 0) {
      let movActivo = this.state.elementos
        .filter( (word) => word.idPlataforma?.nombre?.includes(this.state.plataforma.search) )
        .sort()[this.state.selectedRow];
      if (movActivo) {
        if (movActivo.idPlataforma) {
          if (this.props.PlataformasPerfiles[movActivo.idPlataforma?.id]) {
            let funcionalidadesTemp = this.props.PlataformasPerfiles[
              movActivo.idPlataforma?.id
            ].funcionalidades;
            if (!funcionalidadesTemp) {
              return false;
            }
            for (let item of funcionalidadesTemp) {
              if (item.nombre === elemento) {
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  };
  getFuncionalidadGeneral = (elemento) => {
    var BreakException = {};
    var resultado = false;

    try {
      Object.keys(this.props.PlataformasPerfiles).forEach((key, indice) => {
        if (this.props.PlataformasPerfiles[key].funcionalidades) {
          for (let item of this.props.PlataformasPerfiles[key]
            .funcionalidades) {
            if (item.nombre === elemento) {
              resultado = true;
              throw BreakException;
            }
          }
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
      return resultado;
    }
    return false;
  };

  getCambiosNav = (movimientoOld, MovimientoUpdated) => {    
    let camposmodificados = "";
    let getCampoMod = "";
    let bitacora = 3;
    if (MovimientoUpdated.idOperacionEstatus && 3 === MovimientoUpdated.idOperacionEstatus.id) {
      bitacora = 1;
      if (camposmodificados.length > 0) {
        camposmodificados = camposmodificados + ",  ";
      }
      camposmodificados = camposmodificados + "( ";
      camposmodificados = camposmodificados + "Se finaliza Movimiento )";
    } //Finalizado

    if (MovimientoUpdated.idRuta) {
      if (movimientoOld.idRuta.id) {
        if (movimientoOld.idRuta.id !== MovimientoUpdated.idRuta.id) {
          bitacora = 8;
          if (camposmodificados.length > 0) {
            camposmodificados = camposmodificados + ",  ";
          }
          camposmodificados = camposmodificados + "( ";
          camposmodificados =
            camposmodificados +
            movimientoOld.idRuta.nombre +
            " a " +
            MovimientoUpdated.idRuta.nombre +
            ")";
        }
      } else {
        camposmodificados =
          camposmodificados + MovimientoUpdated.idRuta.nombre + ")";
      }
    }
    ///////////////////////////////////////////////////////////////////////////////////////77
    if (MovimientoUpdated.idOtd) {
      if (movimientoOld.idOtd.id) {
        if (movimientoOld.idOtd.id !== MovimientoUpdated.idOtd.id) {
          bitacora = 11;
          if (camposmodificados.length > 0) {
            camposmodificados = camposmodificados + ",  ";
          }
          camposmodificados = camposmodificados + "( ";
          camposmodificados =
            camposmodificados +
            movimientoOld.idOtd.nombre +
            " a " +
            MovimientoUpdated.idOtd.nombre +
            ")";
        }
      } else {
        camposmodificados =
          camposmodificados + MovimientoUpdated.idOtd.nombre + ")";
      }
    }
    ///////////////////////////////////////////////////////////////////////////////////////77
    if (MovimientoUpdated.idCliente) {
      if (movimientoOld.idCliente.id) {
        if (movimientoOld.idCliente.id !== MovimientoUpdated.idCliente.id) {
          bitacora = 12;
          if (camposmodificados.length > 0) {
            camposmodificados = camposmodificados + ",  ";
          }
          camposmodificados = camposmodificados + "( ";
          camposmodificados =
            camposmodificados +
            movimientoOld.idCliente.nombre +
            " a " +
            MovimientoUpdated.idCliente.nombre +
            ")";
        }
      } else {
        camposmodificados =
          camposmodificados + MovimientoUpdated.idCliente.nombre + ")";
      }
    }
    ///////////////////////////////////////////////////////////////////////////////////////77
    if (MovimientoUpdated.idMovimientoTipo) {
      if (movimientoOld.idMovimientoTipo.id) {
        if (
          movimientoOld.idMovimientoTipo.id !==
          MovimientoUpdated.idMovimientoTipo.id
        ) {
          bitacora = 14;
          if (camposmodificados.length > 0) {
            camposmodificados = camposmodificados + ",  ";
          }
          camposmodificados = camposmodificados + "( ";
          camposmodificados =
            camposmodificados +
            movimientoOld.idMovimientoTipo.nombre +
            " a " +
            MovimientoUpdated.idMovimientoTipo.nombre +
            ")";
        }
      } else {
        camposmodificados =
          camposmodificados + MovimientoUpdated.idMovimientoTipo.nombre + ")";
      }
    }
    ///////////////////////////////////////////////////////////////////////////////////////77
    if (MovimientoUpdated.idOperacionTipo) {
      if (movimientoOld.idOperacionTipo.id) {
        if (
          movimientoOld.idOperacionTipo.id !==
          MovimientoUpdated.idOperacionTipo.id
        ) {
          bitacora = 15;
          if (camposmodificados.length > 0) {
            camposmodificados = camposmodificados + ",  ";
          }
          camposmodificados = camposmodificados + "( ";
          camposmodificados =
            camposmodificados +
            movimientoOld.idOperacionTipo.nombre +
            " a " +
            MovimientoUpdated.idOperacionTipo.nombre +
            ")";
        }
      } else {
        camposmodificados =
          camposmodificados + MovimientoUpdated.idOperacionTipo.nombre + ")";
      }
    }
    ///////////////////////////////////////////////////////////////////////////////////////77
    if (MovimientoUpdated.idRuta2) {
      if (movimientoOld.idRuta2.id) {
        if (movimientoOld.idRuta2.id !== MovimientoUpdated.idRuta2.id) {
          bitacora = 16;
          if (camposmodificados.length > 0) {
            camposmodificados = camposmodificados + ",  ";
          }
          camposmodificados = camposmodificados + "( ";
          camposmodificados =
            camposmodificados +
            movimientoOld.idRuta2.nombre +
            " a " +
            MovimientoUpdated.idRuta2.nombre +
            ")";
        }
      } else {
        camposmodificados =
          camposmodificados + MovimientoUpdated.idRuta2.nombre + ")";
      }
    }

    if (movimientoOld.citaProgramada !== MovimientoUpdated.citaProgramada) {
      bitacora = 3;
      if (camposmodificados.length > 0) {
        camposmodificados = camposmodificados + ",  ";
      }
      camposmodificados = camposmodificados + "( ";
      if (movimientoOld.citaProgramada) {
        camposmodificados =
          camposmodificados +
          movimientoOld.citaProgramada +
          " a " +
          MovimientoUpdated.citaProgramada +
          ")";
      } else {
        camposmodificados =
          camposmodificados + MovimientoUpdated.citaProgramada + ")";
      }
    }
    if (movimientoOld.sello !== MovimientoUpdated.sello) {
      bitacora = 9;
      if (camposmodificados.length > 0) {
        camposmodificados = camposmodificados + ",  ";
      }
      camposmodificados = camposmodificados + "( ";
      if (movimientoOld.sello) {
        camposmodificados =
          camposmodificados +
          movimientoOld.sello +
          " a " +
          MovimientoUpdated.sello +
          ")";
      } else {
        camposmodificados = camposmodificados + MovimientoUpdated.sello + ")";
      }
    } //No aplica a full
    if (movimientoOld.contenedor !== MovimientoUpdated.contenedor) {
      bitacora = 10;
      if (camposmodificados.length > 0) {
        camposmodificados = camposmodificados + ",  ";
      }
      camposmodificados = camposmodificados + "( ";
      if (movimientoOld.contenedor) {
        camposmodificados =
          camposmodificados +
          movimientoOld.contenedor +
          " a " +
          MovimientoUpdated.contenedor +
          ")";
      } else {
        camposmodificados =
          camposmodificados + MovimientoUpdated.contenedor + ")";
      }
    } //No aplica afull
    if (movimientoOld.actualizarFull && movimientoOld.actualizarFull !== MovimientoUpdated.actualizarFull) {
      bitacora = 13;
      if (camposmodificados.length > 0) {
        camposmodificados = camposmodificados + ",  ";
      }
      camposmodificados = camposmodificados + "( ";
      camposmodificados =
        camposmodificados +
        movimientoOld.actualizarFull +
        " a " +
        MovimientoUpdated.actualizarFull +
        ")";
    }

    if (movimientoOld.idRuta2 !== MovimientoUpdated.idRuta2) {
      bitacora = 16;
      if (camposmodificados.length > 0) {
        camposmodificados = camposmodificados + ",  ";
      }
      camposmodificados = camposmodificados + "( ";
      if (movimientoOld.idRuta2) {
        camposmodificados =
          camposmodificados +
          movimientoOld.idRuta2.nombre +
          " a " +
          MovimientoUpdated.idRuta2.nombre +
          ")";
      } else {
        camposmodificados =
          camposmodificados + MovimientoUpdated.idRuta2.nombre + ")";
      }
    }
    //this.camposLogisticosNav
    this.camposLogisticosNav.map((cLog, index) => {
      switch (cLog.nombreCampo) {
        /**
         * Importacion
         */
        case "arribo_terminal_vacio":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "arriboTerminalVacio",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "salida_terminal_lleno":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "salidaTerminalLleno",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "arribo_cliente_lleno":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "arriboClienteLleno",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "salida_cliente_vacio":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "salidaClienteVacio",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "arribo_terminal_vacio_2":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "arriboTerminalVacio2",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "asignacion_piloto":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "asignacionPiloto",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "inicio_ruta":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "inicioRuta",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "despacho_predio_cliente":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "despachoPredioCliente",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "llegada_frontera":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "llegadaFrontera",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "salida_frontera":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "salidaFrontera",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "arribo_aduana":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "arriboAduana",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "salida_aduana":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "salidaAduana",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        /**
         * Exportacion
         */
        case "retiro_contenedor":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "retiroContenedor",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "arribo_cliente_vacio":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "arriboClienteVacio",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "salida_cliente_lleno":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "salidaClienteLleno",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "arribo_terminal_cargado":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "arriboTerminalCargado",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "salida_predio_vacio":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "salidaPredioVacio",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "cita_fecha_despacho":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "citaFechaDespacho",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "entrada_ciudad_portuaria":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "entradaCiudadPortuaria",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "arribo_patio_linea":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "arriboPatioLinea",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        case "salida_terminal_vacio":
          getCampoMod = this.validarLogisTicos(
            movimientoOld,
            MovimientoUpdated,
            camposmodificados,
            "salidaTerminalVacio",
            cLog.nombre
          );
          if (getCampoMod !== camposmodificados) {
            bitacora = 3;
            camposmodificados = getCampoMod;
          }
          break;
        default:
          break;
      }
      return cLog;
    });

    return { bitacora: bitacora, camposmodificados: camposmodificados };
  };
  validarLogisTicos = (
    movimientoOld,
    MovimientoUpdated,
    camposmodificados,
    campo,
    labelLog
  ) => {
    let camposmodificadosTemp = camposmodificados;
    if (movimientoOld[campo] !== MovimientoUpdated[campo]) {
      if (camposmodificadosTemp.length > 0) {
        camposmodificadosTemp = camposmodificadosTemp + ",  ";
      }
      camposmodificadosTemp = camposmodificadosTemp + "(  " + labelLog + ": ";
      if (movimientoOld[campo]) {
        camposmodificadosTemp =
          camposmodificadosTemp +
          movimientoOld[campo] +
          " a " +
          MovimientoUpdated[campo] +
          " )";
      } else {
        camposmodificadosTemp =
          camposmodificadosTemp + MovimientoUpdated[campo] + " )";
      }
    }
    return camposmodificadosTemp;
  };
  crud = (
    metodo = "get",
    obj = [],
    id = "",
    catalogo = "",
    stateVar = "",
    hiddenModl = ""
  ) => {
    return Crud_Catalogos(
      catalogo,
      "movimientos",
      metodo,
      id,
      obj,
      "",
      stateVar,
      hiddenModl,
      []
    )
      .then((returnVal) => {
        switch (metodo) {
          case "get":
            if (stateVar === "camposLogisticos") {
              return returnVal;
            }
            if( stateVar === "remolquesTipo"){
              for(let r of returnVal){
                this.remolques[r.idRemolque]= r;
              }
            }
            if (stateVar === "urlGps") {
              window.open(
                returnVal.url,
                "sharer",
                "width=900,height=600,scrollbars=NO"
              );
            }
            if (stateVar === "entregas") {
              this.setState({ loadingEntregas: false });
              if (returnVal) {
                this.setState({ entregas: returnVal });
              } else {
                this.setState({ entregas: [] });
              }
              return returnVal;
            }
            if (stateVar === "informes") {
              let informesTemp = {};
              for (let item of returnVal) {
                if (item.id === 3) {
                  //  3 equipos vacios
                  informesTemp[item.id] = item;
                  this.crud(
                    "get",
                    "",
                    "",
                    "funcionalidades/informe/" + item.id,
                    "funcionalidades3"
                  );
                }
                if (item.id === 4) {
                  //  4 Exportar Reporte AD-HOC C4
                  informesTemp[item.id] = item;
                  this.crud(
                    "get",
                    "",
                    "",
                    "funcionalidades/informe/" + item.id,
                    "funcionalidades4"
                  );
                }
                if (item.id === 69) {
                  //  4 Exportar Reporte AD-HOC C4
                  informesTemp[item.id] = item;
                  this.crud(
                    "get",
                    "",
                    "",
                    "funcionalidades/informe/" + item.id,
                    "funcionalidades69"
                  );
                }
                if (item.id === 70) {
                  //  4 Exportar Reporte AD-HOC C4
                  informesTemp[item.id] = item;
                  this.crud(
                    "get",
                    "",
                    "",
                    "funcionalidades/informe/" + item.id,
                    "funcionalidades70"
                  );
                }
              }
              this.setState({ informes: informesTemp });
            }
            if (stateVar === "funcionalidades3" && returnVal) {
              this.setState({ informe3: returnVal });
              let movsTemp = [];
              this.state.elementos.map((m, index) => {
                movsTemp[index] = {};
                for (let item of returnVal) {
                  movsTemp[index][item.label] = m[item.nombre];
                }
                return m;
              });
              this.setState({ reporte3: movsTemp });
            }
            if (stateVar === "funcionalidades4" && returnVal) {
              this.setState({ informe4: returnVal });
              let movsTemp = [];
              this.state.elementos.map((m, index) => {
                movsTemp[index] = {};
                for (let item of returnVal) {
                  movsTemp[index][item.label] = m[item.nombre];
                }
                return m;
              });
              this.setState({ reporte4: movsTemp });
            }
            if (stateVar === "funcionalidades69" && returnVal) {
              this.setState({ informe69: returnVal });
              let movsTemp = [];
              this.crud(
                "get",
                [],
                "",
                "navieraMovimientos/movimientosImportacionSemanal_c4/" +
                  new Date().getFullYear() +
                  "/" +
                  new Date().getWeekNumber(),
                "data"
              ).then((movs) => {
                if (movs) {
                  movs.map((m, index) => {
                    movsTemp[index] = {};
                    for (let item of returnVal) {
                      movsTemp[index][item.label] = m[item.nombre];
                    }
                    return m;
                  });
                  this.setState({ reporte69: movsTemp });
                }
              });
            }
            if (stateVar === "funcionalidades70" && returnVal) {
              this.setState({ informe70: returnVal });
              let movsTemp = [];
              this.crud(
                "get",
                [],
                "",
                "navieraMovimientos/movimientosExportacionSemanal_c4/" +
                  new Date().getFullYear() +
                  "/" +
                  new Date().getWeekNumber(),
                "data"
              ).then((movs) => {
                if (movs) {
                  movs.map((m, index) => {
                    movsTemp[index] = {};
                    for (let item of returnVal) {
                      movsTemp[index][item.label] = m[item.nombre];
                    }
                    return m;
                  });
                  this.setState({ reporte70: movsTemp });
                }
              });
            }
            return returnVal;
          case "post":
            if (stateVar === "serviceFailure") {
              this.hiddenmodal();
              return returnVal;
            }
            break;
          case "put":
            if (stateVar === "updateFechas") {
              this.hiddenmodal();
              let movId = (id && id.id) || (id && id.idMovimiento) || returnVal.id;
              let movsTemp = [...this.state.elementos];
              for (let i = 0; i < movsTemp.length; i++) {
                if (movsTemp[i].id === movId) {
                  movsTemp[i].contenedor = obj.contenedor;
                  movsTemp[i].sello = obj.sello;
                  this.setState({ elementos: movsTemp });
                  this.movsReport = movsTemp;
                  break;
                }
              }
              NotificationManager.info(
                "Se ha actualizado mov: " + movId,
                "Actualizacion"
              );
              // Construir movimiento actualizado usando oldMov como base + campos que cambiaron
              let movUpdated = {...id, contenedor: obj.contenedor, sello: obj.sello};
              if(returnVal.idOperacionEstatus) { movUpdated.idOperacionEstatus = returnVal.idOperacionEstatus; }
              if(returnVal.idRuta) { movUpdated.idRuta = returnVal.idRuta; }
              if(returnVal.idOtd) { movUpdated.idOtd = returnVal.idOtd; }
              if(returnVal.idCliente) { movUpdated.idCliente = returnVal.idCliente; }
              if(returnVal.citaProgramada) { movUpdated.citaProgramada = returnVal.citaProgramada; }
              let cambios = this.getCambiosNav(id, movUpdated);
              this.usuariosLogObject.idBitacoraMonitoreo = cambios.bitacora;
              this.usuariosLogObject.idUsuario = user.id;
              this.usuariosLogObject.idMovimiento = movId;
              this.usuariosLogObject.idPlataformaTipo = 1;
              this.usuariosLogObject.accionFecha = myFormato(new Date());
              this.usuariosLogObject.descripcion = cambios.camposmodificados;
              this.crud(
                "get",
                "",
                "",
                "camposLogisticos/plataforma/" +
                  id.idPlataforma.id +
                  "/mtipo/" +
                  id.idMovimientoTipo.id,
                "camposLogisticos"
              ).then((returnVal1) => {
                this.camposLogisticosNav = returnVal1;
                Crud_Catalogos(
                  "usuariosLog",
                  catalogo,
                  "post",
                  "",
                  this.usuariosLogObject
                );
              });
            }
            break;
          default:
            break;
        }
      })
      .catch((err) => {
        if (stateVar === "entregas") {
          this.setState({ loadingEntregas: false });
        }
        console.log(err);
      });
  };
  buscar = () => {
    //@GetMapping("/usuario_personalizado/{idUsuario}/fecha1/{fecha1}/fecha2/{fecha2}")/
    let movimientosBy = 0;
    this.setState({ elementos: [] });
    this.movsReport = [];
    this.props.setMovimientosNavieros([]);
    if (window.location.host.includes("skyone.skyangel.com.mx") || window.location.host.includes("localhost:3000")) {
      movimientosBy = currentUser[0].perfil.movimientosBy;
    } else {
      for (let s of subDominios) {
        if (window.location.host.includes(s.dominio)) {
          for (let cUser of currentUser) {
            if (cUser.plataforma.nombre === s.plataforma) {
              this.crud(
                "get",
                "",
                "",
                "informes/perfil/" + cUser.perfil.id,
                "informes"
              );
              movimientosBy = cUser.perfil.movimientosBy;
              break;
            }
          }
        }
      }
    }
    if (movimientosBy === 1) {//821 por cita, 738  por fecha creacion
      //perfil
      this.getfuntion(
        "get",
        [],
        "",
        [],
        "navieraMovimientosPerfil/personalizado_finalizados/movimiento_tipo/"
          + this.props.mtipo
          + "/fecha1/"
          + this.state.fecha1
          + " 00:00:00/fecha2/"
          + this.state.fecha2
          + " 23:59:59",
        this.props.movimientos_naviera_update
      );
      /*
      switch (this.props.mtipo) {
        case 0:
          this.getfuntion(
            "get",
            [],
            "",
            [],
            "navieraMovimientosPerfil/usuario_personalizado/" +
              user.id +
              "/fecha1/" +
              this.state.fecha1 +
              " 00:00:00/fecha2/" +
              this.state.fecha2 +
              " 23:59:59",
            this.props.movimientos_naviera_update
          );
          break;
        default:
          this.getfuntion(
            "get",
            [],
            "",
            [],
            "navieraMovimientosPerfil/personalizado_finalizados/" +
              user.id +
              "/" +
              this.props.mtipo +
              "/fecha1/" +
              this.state.fecha1 +
              " 00:00:00/fecha2/" +
              this.state.fecha2 +
              " 23:59:59",
            this.props.movimientos_naviera_update
          );
          break;
      }*/
    }
    if (movimientosBy === 2) {
      //corredores
      switch (this.props.mtipo) {
        case 0:
          this.getfuntion(
            "get",
            [],
            "",
            [],
            "navieraMovimientosPerfil/usuario/" +
              user.id +
              "/fecha1/" +
              this.state.fecha1 +
              " 00:00:00/fecha2/" +
              this.state.fecha2 +
              " 23:59:59",
            this.props.movimientos_naviera_update
          );
          break;
        default:
          this.getfuntion(
            "get",
            [],
            "",
            [],
            "navieraMovimientosPerfil/usuario/" +
              user.id +
              "/" +
              this.props.mtipo +
              "/fecha1/" +
              this.state.fecha1 +
              " 00:00:00/fecha2/" +
              this.state.fecha2 +
              " 23:59:59",
            this.props.movimientos_naviera_update
          );
          break;
      }
    }
    if (movimientosBy === 3) {
      //transportistas
      switch (this.props.mtipo) {
        case 0:
          this.getfuntion(
            "get",
            [],
            "",
            [],
            "navieraMovimientosPerfil/usuario_transportista/" +
              user.id +
              "/fecha1/" +
              this.state.fecha1 +
              " 00:00:00/fecha2/" +
              this.state.fecha2 +
              " 23:59:59",
            this.props.movimientos_naviera_update
          );
          break;
        default:
          this.getfuntion(
            "get",
            [],
            "",
            [],
            "navieraMovimientosPerfil/usuario_transportista/" +
              user.id +
              "/" +
              this.props.mtipo +
              "/fecha1/" +
              this.state.fecha1 +
              " 00:00:00/fecha2/" +
              this.state.fecha2 +
              " 23:59:59",
            this.props.movimientos_naviera_update
          );
          break;
      }
    }
  };
  onChangeFecha1 = (date) => this.setState({ fecha1: date.target.value });
  onChangeFecha2 = (date) => this.setState({ fecha2: date.target.value });

  changeActivos = (event) => {
    this.setState({ activos: event.target.checked, isloading: true, elementos: [], elementosSinfiltrar: [] }, () => {
      if (this.state.activos) {
        this.props.setMovimientosNavieros([]);
        this.obtenerMovimientos();
        if (this.state.autoRefresh) this.startAutoRefresh();
      } else {
        this.stopAutoRefresh();
        this.props.setMovimientosNavieros([]);
        this.buscar();
      }
    });
  };

  tracking = (mov, gps) => {
    this.crud(
      "get",
      "",
      "",
      "gpsestatus/rastreame/plataforma/" +
        mov.idPlataforma?.id +
        "/gps/" +
        gps.id,
      "urlGps"
    );
  };

  hideNav = () => {
    this.setState((prev) => ({
      Navigator: !prev.Navigator,
    }));
  };

  getEntregas = () => {
    if (this.state.movimiento.id) {
      this.setState({ loadingEntregas: true });
      this.crud(
        "get",
        "",
        "",
        "entregas_navieras/movimiento/" + this.state.movimiento.id,
        "entregas"
      );
    }
  };
  render() {
    return (
      <div>
        {
          !this.state.isloading ? 

        
        <NotificacionesPatios topic={"/topic/tranportistasPatiosNotificaciones"} 
                  insertarNotificaciones={this.insertarNotificaciones} elementos={this.state.elementosSinfiltrar} 
                  transportista={this.state.idTransportista} localidad={this.state.localidades} 
                  actualizaListaElementos = {this.actualizaListadeElementos}  controlador={this.state.controlador} 
                  plataforma={this.plataformas}/>

                  : null }
        {/* Ícono para abrir modal de conteos para Samsung */}
        {[1316, 1711].includes(this.state.plataforma.value) && (
        <div style={{ position: 'fixed', left: 10, top: '50%', zIndex: 9998, cursor: 'pointer' }}
          onClick={() => this.setState({ showConteoModal: true })}
          title="Ver conteo de horarios"
        >
          <i className="fa fa-clipboard" style={{ fontSize: '28px', color: this.state.elementos.length < this.state.elementosSinfiltrar.length ? '#dc2626' : '#f59e0b' }}></i>
        </div>
        )}
        {/* Modal lateral izquierdo de conteos */}
        {this.state.showConteoModal && (
          <div style={{ position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 9999, display: 'flex' }}>
            <div style={{ width: 320, background: '#fff', boxShadow: '2px 0 10px rgba(0,0,0,0.3)', padding: 20, overflowY: 'auto' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <b style={{ fontSize: 16 }}>Resumen de Horarios</b>
                <button onClick={() => this.setState({ showConteoModal: false })} style={{ border: 'none', background: 'none', fontSize: 20, cursor: 'pointer' }}>✕</button>
              </div>
              <div style={{ marginBottom: 12 }}>
                <b>Hora Máxima Salida</b>
                <p style={{ margin: '4px 0' }}>Menor a 2 horas: <a href="#" onClick={(e)=>{e.preventDefault(); this.filtrarPorConteo('horaMaximaSalida','menor')}}><strong>{this.state.conteoHorarios.hmsMenor}</strong></a></p>
                <p style={{ margin: '4px 0' }}>Mayor a 2 horas: <a href="#" onClick={(e)=>{e.preventDefault(); this.filtrarPorConteo('horaMaximaSalida','mayor')}}><strong>{this.state.conteoHorarios.hmsMayor}</strong></a></p>
              </div>
              <div style={{ marginBottom: 12 }}>
                <b>Cita en Centro Carga próxima a vencer</b>
                <p style={{ margin: '4px 0' }}>Menor a 2 horas: <a href="#" onClick={(e)=>{e.preventDefault(); this.filtrarPorConteo('citaProgramadaTerminal','menor')}}><strong>{this.state.conteoHorarios.cptMenor}</strong></a></p>
                <p style={{ margin: '4px 0' }}>Mayor a 2 horas: <a href="#" onClick={(e)=>{e.preventDefault(); this.filtrarPorConteo('citaProgramadaTerminal','mayor')}}><strong>{this.state.conteoHorarios.cptMayor}</strong></a></p>
              </div>
              <div style={{ marginBottom: 12 }}>
                <b>Cita en cliente Próxima a vencer</b>
                <p style={{ margin: '4px 0' }}>Menor a 2 horas: <a href="#" onClick={(e)=>{e.preventDefault(); this.filtrarPorConteo('citaProgramada','menor')}}><strong>{this.state.conteoHorarios.cpMenor}</strong></a></p>
                <p style={{ margin: '4px 0' }}>Mayor a 2 horas: <a href="#" onClick={(e)=>{e.preventDefault(); this.filtrarPorConteo('citaProgramada','mayor')}}><strong>{this.state.conteoHorarios.cpMayor}</strong></a></p>
              </div>
              <div style={{ marginTop: 16 }}>
                <a href="#" onClick={(e)=>{e.preventDefault(); this.setState({ elementos: this.state.elementosSinfiltrar, showConteoModal: false })}}>Mostrar todos los movimientos</a>
              </div>
            </div>
            <div style={{ flex: 1 }} onClick={() => this.setState({ showConteoModal: false })}></div>
          </div>
        )}
        <div className={`${classes.jumb}`}>
          <div className="row form-row align-items-center ">
            <div class="col-2">
              <Select
                value={this.state.plataforma}
                onChange={this.changePlataformas}
                options={this.plataformas}
              />
            </div>
            {false && this.getFuncionalidadGeneral("Exportar") ? (
              <div class="col-auto">
                <Exportar
                  crud={this.getfuntion}
                  catalogo={this.catalogo}
                  filtro={""}
                  data={this.state.movsReport}
                  title={"Reporte general"}
                />
              </div>
            ):null}
            {/* {idPlataforma.id == 1  ?(

              <div>
                 <div class="col-auto">
                  <Select options={this.state.localidades} styles={colourStyles} onChange={this.cambioLocalidad}/>
                </div>

              </div>
               
              ):null}  */}
            
            {this.getFuncionalidadGeneral("Exportar") &&
              this.state.excelRender &&
              this.state.informes[3] ? (
                <div class="col-auto">
                  <Exportar
                    crud={this.getfuntion}
                    catalogo={this.catalogo}
                    filtro={"/usuario/" + user.id}
                    data={this.state.reporte3}
                    title={this.state.informes[3].nombre}
                  />
                </div>
              ):null}
            {this.getFuncionalidadGeneral("Exportar") &&
              this.state.excelRender &&
              this.state.informes[4] ? (
                <div class="col-auto">
                  <Exportar
                    crud={this.getfuntion}
                    catalogo={this.catalogo}
                    filtro={"/usuario/" + user.id}
                    data={this.state.reporte3}
                    title={this.state.informes[3].nombre}
                  />
                </div>
              ):null}
            {this.getFuncionalidadGeneral("Exportar") &&
              this.state.excelRender &&
              this.state.informes[69] ?(
                <div class="col-auto">
                  <Exportar
                    crud={this.getfuntion}
                    catalogo={this.catalogo}
                    filtro={"/usuario/" + user.id}
                    data={this.state.reporte69}
                    title={this.state.informes[69].nombre}
                  />
                </div>
              ): null}
            {this.getFuncionalidadGeneral("Exportar") &&
              this.state.excelRender &&
              this.state.informes[70] ?(
                <div class="col-auto">
                  <Exportar
                    crud={this.getfuntion}
                    catalogo={this.catalogo}
                    filtro={"/usuario/" + user.id}
                    data={this.state.reporte70}
                    title={this.state.informes[70].nombre}
                  />
                </div>
              ):null}


             {/* Toggle movido al titulo de la tabla (junto a "Movimientos") */}
             {false ?
            <div className="col-auto">
              <div className="form-check form-switch">
                <Form.Switch
                  type="Checkbox"
                  checked={this.state.activos}
                  onChange={this.changeActivos}
                />
                <label
                  className="form-check-label"
                  for="flexSwitchCheckChecked"
                >
                  {this.state.activos 
                    ? "Movimientos Activos"
                    : "Movimientos Finalizados"}
                </label>
              </div>
            </div>
            : null}
            <div hidden={!this.state.movimiento.idPlataforma || ![952].includes(this.state.movimiento.idPlataforma.id)}>
              <ModalLayout
                title={"Reporte de incidencias"}
                name={<i class="fa fa-file-excel-o icon-large" data-toggle="tooltip"
                  data-placement="top" title="Repoete de incidencias"
                  onClick={  
                    () => {                 
                      this.setState({ incidenciasReporte: []});
                      if(this.state.activos){
                        Crud_Catalogos(
                          "movimientoIncidencias/personalizado"+(this.props.mtipo?("/movimiento_tipo/" + this.props.mtipo): "")
                          ,""
                          ,"get"
                          ,""
                          ,[],"","","",[]).then((returnVal)=>{                                                
                            this.setState({ incidenciasReporte: returnVal});
                        }).catch(err =>{ console.log(err);});
                      }else{
                        if(this.state.elementos.length){
                          Crud_Catalogos(
                            "movimientoIncidencias/personalizado_finalizados"
                            +"/movimiento_tipo/" + this.props.mtipo
                            + "/fecha1/" + this.state.fecha1
                            + " 00:00:00/fecha2/"
                            + this.state.fecha2
                            + " 23:59:59"
                            ,""
                            ,"get"
                            ,""
                            ,[],"","","",[]).then((returnVal)=>{                                                
                              this.setState({ incidenciasReporte: returnVal});
                          }).catch(err =>{ console.log(err);});
                        }
                      }
                    }
                  }> Incidencias</i>}
                hiddenModal={this.state.hiddenModals} Fclose={this.hiddenmodal}
                formulario={
                  <TablePageable
                    titulo={<h3> { this.state.activos
                      ?"Reporte de incidencias Movimientos activos"
                      :"Reporte de incidencias Movimientos Finalizados"
                    } </h3>}
                    lista={ this.state.incidenciasReporte }
                  columnas={
                    [
                      { columna: "id", label: "Id" },
                      { columna: "idMovimiento", label: "idMovimiento" },
                      { columna: "fechaCreado", label: "fecha" },
                      { columna: "incidencia.nombre", label: "Incidencia" },
                      { columna: "incidencia.incidenciaTipo.nombre", label: "Tipo" },
                      { columna: "comentario", label: "Comentario" },
                    ]
                  }
                  id="id"
                  //selected={(e) => this.setState({ movimiento: e}) }
                  csvname={ this.state.activos
                            ?"Reporte de incidencias Movs activos"
                            :"Reporte de incidencias Movs Finalizados"
                          }
                />                              
                }
              />
            </div>
            {/* Fechas movidas al titulo de la tabla (junto a "Movimientos") */}
            {false && this.getFuncionalidadGeneral("movimientosFinalizados") && !this.state.activos ? (
              <div class="col-auto">
                <span className="float-right ml-2">
                  <Button
                    pill
                    size="sm"
                    outline
                    color="primary"
                    onClick={() => this.buscar()}
                  >
                    <Icon name="refresh-cw" />
                  </Button>


                </span>
                <span className="float-right ml-2 width-35-percent">
                  <input
                    type="date"
                    id="start"
                    name="trip-start"
                    value={this.state.fecha2}
                    onChange={this.onChangeFecha2}
                  />
                </span>
                <span className="float-right ml-2"> - </span>
                <span className="float-right ml-2 width-35-percent">
                  <input
                    type="date"
                    id="start"
                    name="trip-start"
                    value={this.state.fecha1}
                    onChange={this.onChangeFecha1}
                  />
                </span>
              </div>   
            ):null}
            <div hidden={  [13323, 53607].includes(user.id)  || !this.state.movimiento.id}>
                <ModalLayout
                  title={"Incidencias del movimiento "+ this.state.movimiento.id}
                  name={<Button pill size="sm" outline color="primary"
                  tamanio= "100%"
                  onClick={  
                          () => {
                            Crud_Catalogos("movimientoIncidencias/movimiento/"+this.state.movimiento.id,"","get","",[],"","","",[]).then((returnVal)=>{                                                
                              this.setState({incidencias: returnVal});
                            }).catch(err =>{ console.log(err);});
                            }
                    } ><Icon name="list" />{"Incidencias mov ("+ this.state.movimiento.id+")"}</Button>}
                  hiddenModal={this.state.hiddenModals} Fclose={this.hiddenmodal}
                  formulario={
                      <TablePageable
                          titulo={<h3> { "incidencias" } </h3>}
                          lista={ this.state.incidencias && this.state.incidencias.length?(perfilOneLine
                            ? this.state.incidencias.filter(i=> ![7].includes(i.incidencia.incidenciaTipo.id))
                            : this.state.incidencias): []
                          }
                        columnas={
                          [
                            { columna: "id", label: "Id" },
                            { columna: "idMovimiento", label: "idMovimiento" },
                            { columna: "fechaCreado", label: "fecha" },
                            { columna: "incidencia.nombre", label: "Incidencia" },
                            //{ columna: "incidencia.incidenciaTipo.nombre", label: "Tipo" },
                            { columna: "comentario", label: "Comentario" },
                          ]
                        }
                        id="id"
                        //selected={(e) => this.setState({ movimiento: e}) }
                        csvname={"Incidencias del movimiento "+ this.state.movimiento.id}
                      />                                
                  }
                />
                
            </div>

            <div hidden={this.state.movimiento.idPlataforma?.id != 1 || !this.state.movimiento.id}>
                <ModalLayout
                  title={"Bitacora del movimiento "+ this.state.movimiento.id}
                  name={<Button pill size="sm" outline color="primary" 
                  onClick={  
                          () => {                 
                            let contador=0;
                            Crud_Catalogos("usuariosLog/idmovimiento/"+this.state.movimiento.id + "/plataformatipo/1/","","get","",[],"","","",[]).then((returnVal)=>{                                                
                              this.setState({bitacora: returnVal});
                              setTimeout(() => {
                                this.table_headers_bitacora(true, "fechaCreado");
                                //this.sortIncidencias("fechaCreado");
                              }, 100);
                            }).catch(err =>{ console.log(err);});
                            }
                    } ><Icon name="list" />{"Bitacora del  mov ("+ this.state.movimiento.id+")"}</Button>}
                  hiddenModal={this.state.hiddenModals} Fclose={this.hiddenmodal}
                  formulario={
                    <Dimmer active={this.state.loadingEntregas} loader>
                      <Table cards={false} striped={false} responsive={true} className="table-vcenter table-black-80" > {/** headerItems={ this.state.incidenciatableheader} */}
                        <Table.Header>
                          {this.state.bitacoratableheader.map((item, i) =>
                              <Table.ColHeader key={i}>
                                {item.content}
                              </Table.ColHeader>)}
                        </Table.Header>{/* incidenciaColumna* */}
                        <Table.Body>
                          {
                         
                         this.state.bitacora&&//se ocultan bitacora de gps(7) ejp: Gps reportando sin velocidad
                          this.state.bitacora.map((e, index) =>
                              <Table.Row >
                                <Table.Col>{e.idBitacoraMonitoreo}</Table.Col>
                                <Table.Col>{e.descripcion}</Table.Col>
                                <Table.Col>{e.idUsuario}</Table.Col>
                                <Table.Col>{e.accionFecha}</Table.Col>
                                                                                  
                              </Table.Row>
                            )}
                          
                        </Table.Body>
                      </Table>
                    </Dimmer>                                    
                  }
                />
                
            </div>
            {this.state.movimiento.idPlataforma &&
              this.state.movimiento.idPlataforma?.plataformaTipo?.id === 3 && !transportista ? (
                <div class="col-auto">
                  <span className="float-right ml-4">
                    <ModalLayout
                      title={"Entregas del mov: " + this.state.movimiento.id}
                      name={
                        <Button
                          pill
                          size="sm"
                          outline
                          color="primary"
                          onClick={() => this.getEntregas()}
                        >
                          <Icon name="list" />
                          Entregas
                        </Button>
                      }
                      hiddenModal={this.state.hiddenModals}
                      Fclose={this.hiddenmodal}
                      formulario={
                        <Dimmer active={this.state.loadingEntregas} loader>
                          <Table
                            cards={false}
                            striped={false}
                            responsive={true}
                            className="table-vcenter text-black font-80"
                            headerItems={[
                              { content: "idEntrega" },
                              { content: "idMovimiento" },
                              { content: "destino" },
                              { content: "direccion" },
                              { content: "fechaArribo" },
                              { content: "fechaSalida" },
                              { content: "latitud" },
                              { content: "longitud" },
                            ]}
                          >
                            <Table.Header />
                            <Table.Body>
                              {this.state.entregas.sort().map((e, index) => (
                                <Table.Row>
                                  <Table.Col>{e["idEntrega"]}</Table.Col>
                                  <Table.Col>{e["idMovimiento"]}</Table.Col>
                                  <Table.Col>{e["destino"]}</Table.Col>
                                  <Table.Col>{e["direccion"]}</Table.Col>
                                  <Table.Col>{e["fechaArribo"]}</Table.Col>
                                  <Table.Col>{e["fechaSalida"]}</Table.Col>
                                  <Table.Col>{e["latitud"]}</Table.Col>
                                  <Table.Col>{e["longitud"]}</Table.Col>
                                </Table.Row>
                              ))}
                            </Table.Body>
                          </Table>
                        </Dimmer>
                      }
                    />

                    
                  </span>
                </div>
              ): null}

            {window.location.host.includes("intermodalmaersk.com") ? (
              <div class="col-auto">
                <Button
                  pill
                  size="sm"
                  outline
                  color="primary"
                  onClick={() =>
                    (window.location.href =
                      "https://app.powerbi.com/view?r=eyJrIjoiM2FjMjA3NjAtY2I0NC00NWVmLTk3YjMtYjZjY2FjOWRiNWVhIiwidCI6IjNmNjdkMmVjLWVlM2YtNDJiZS1iMDBmLWY2NjgyNDZiOGFkZiJ9")
                  }
                >
                  <Icon name="activity" />
                  Reporte OTD
                </Button>
              </div>
            ):null}
            {user.id === 6584 ? (
              <div class="col-auto">
                <Button
                  pill
                  size="sm"
                  outline
                  color="primary"
                  onClick={() =>
                    (window.location.href =
                      "https://app.powerbi.com/view?r=eyJrIjoiZGNlOGUwYTQtYWM1Mi00MjE4LWEzZGItZGUwZWQ4NWU4MDI1IiwidCI6IjNmNjdkMmVjLWVlM2YtNDJiZS1iMDBmLWY2NjgyNDZiOGFkZiJ9")
                  }
                >
                  <Icon name="activity" />
                  Dashboard Aceros Guatemala
                </Button>
              </div>
            ):null}
            {[281, 6].includes(user.id) ? (
              <div class="col-auto">
                <Button
                  pill
                  size="sm"
                  outline
                  color="primary"
                  onClick={() =>
                    (window.location.href =
                      //"https://app.powerbi.com/view?r=eyJrIjoiNTA4ODZlNTEtNDlkMS00ZDhlLWE5ZjItMjUxZTkyYzNjMzZlIiwidCI6ImFiM2FmMjJkLWI4ZjEtNGE1Yy05M2NhLWNiMDVkZGE0OGFjZCJ9"
                      "https://app.powerbi.com/view?r=eyJrIjoiOTRjZmEyNjQtZmIxZC00OTkxLWE5YmYtYmNjMDI2YjAzNmQzIiwidCI6ImFiM2FmMjJkLWI4ZjEtNGE1Yy05M2NhLWNiMDVkZGE0OGFjZCJ9"
                    )
                  }
                >
                  <Icon name="activity" />
                  KPIS CMA
                </Button>
              </div>
            ): null}
            { this.plataformas
              .filter(p=> [3,94,100,556,688].includes(p.value)).length && user.id !== 281  && (!controlador && !transportista) ? (//cma 3,94,100,556,688
              <div class="col-auto">
                <Button
                  pill
                  size="sm"
                  outline
                  color="primary"
                  onClick={() =>
                    (window.location.href = "https://app.powerbi.com/view?r=eyJrIjoiODQ2ZTE4YWQtY2JiYi00ODU2LWE5MzktYmJhNGRjNTc1ZjZkIiwidCI6ImFiM2FmMjJkLWI4ZjEtNGE1Yy05M2NhLWNiMDVkZGE0OGFjZCJ9&embedImagePlaceholder=true"
                      //"https://app.powerbi.com/view?r=eyJrIjoiY2U4NTA5ZDktMTVkMS00M2Y4LWFlN2MtODk2NjllMzk1NDBhIiwidCI6ImFiM2FmMjJkLWI4ZjEtNGE1Yy05M2NhLWNiMDVkZGE0OGFjZCJ9"
                      //"https://app.powerbi.com/view?r=eyJrIjoiNzY2NzcwNDMtNWI4ZC00MzY3LThjMzItNzlhNWExOTJmMGJiIiwidCI6ImFiM2FmMjJkLWI4ZjEtNGE1Yy05M2NhLWNiMDVkZGE0OGFjZCJ9&pageName=ReportSection"
                    )
                  }
                >
                  <Icon name="activity" />
                  KPI'S CMA
                </Button>
              </div>
            ):null}
                        { this.plataformas
              .filter(p=> [7].includes(p.value)).length && user.id !== 281  && (!controlador && !transportista) ? (//cma 3,94,100,556,688
              <div class="col-auto">
                <Button
                  pill
                  size="sm"
                  outline
                  color="primary"
                  onClick={() =>
                    (window.location.href = "https://app.powerbi.com/view?r=eyJrIjoiZGVmZDhiYmEtMjA0NC00ZDQyLWFmZmYtN2YyZjE4ZTA2Zjc4IiwidCI6ImFiM2FmMjJkLWI4ZjEtNGE1Yy05M2NhLWNiMDVkZGE0OGFjZCJ9"
                      //"https://app.powerbi.com/view?r=eyJrIjoiNzY2NzcwNDMtNWI4ZC00MzY3LThjMzItNzlhNWExOTJmMGJiIiwidCI6ImFiM2FmMjJkLWI4ZjEtNGE1Yy05M2NhLWNiMDVkZGE0OGFjZCJ9&pageName=ReportSection"
                    )
                  }
                >
                  <Icon name="activity" />
                  KPI'S MSC
                </Button>
              </div>
            ):null}
            { this.plataformas//226 Sagot
              .filter(p=> [61, 226].includes(p.value)).length && user.id !== 281 ? (//cma 3,94,100,556,688
              <div class="col-auto">
                <Button
                  pill
                  size="sm"
                  outline
                  color="primary"
                  onClick={() =>
                    (window.location.href =
                      "https://app.powerbi.com/view?r=eyJrIjoiY2UwZTU5ODItYzdlMS00M2JlLTlhYmItMzVkN2IzYzdkNjMyIiwidCI6ImFiM2FmMjJkLWI4ZjEtNGE1Yy05M2NhLWNiMDVkZGE0OGFjZCJ9")
                  }
                >
                  <Icon name="activity" />
                  Dashboard SAGOT
                </Button>
              </div>
            ):null}
            
            <ul>
              { this.plataformas.filter(p=> [1].includes(p.value)).length && !controlador && !transportista ? (
                <li
                  className="badge"
                  onClick={() => window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiZmNiMjUwN2UtY2M3Yy00ZDEwLWE0NjAtN2U3NzhiZjExMTUxIiwidCI6ImFiM2FmMjJkLWI4ZjEtNGE1Yy05M2NhLWNiMDVkZGE0OGFjZCJ9",
                    "sharer",
                    "width=900,height=600,scrollbars=NO"
                  )
                }
                  data-toggle="tooltip"
                  data-placement="top"
                  title={"Maersk Volumen de servicios"}
                >
                  <i className="fa fa-bar-chart icon-large text-primary-pink"></i>
                </li>
              ):null}
            </ul>
            { this.plataformas.filter(p=> [1].includes(p.value)).length && !controlador && !transportista ? (
              <div class="col-auto">
              <ModalLayout                
                name={
                      <Button pill size="sm" outline color="primary">
                        <Icon name="list" />{"Descarga Incidenciass"}
                      </Button>
                      }
                //hiddenModal={this.state.hiddenModals} Fclose={this.hiddenmodal}
                formulario={<IncidenciasFiltro/>}
                //datosForm={{}}
              />
            </div>
            ) : null}
            <div class="col-auto">
              <ModalLayout
                tamanio={"100%"}
                title="Reporte de movimientos"
                name={
                  <Button pill size="sm" outline color="primary">
                    <Icon name="list" />{"Reporte"}
                  </Button>
                }
                hiddenModal={this.state.hiddenModals}
                Fclose={this.hiddenmodal}
                formulario={
                <Reporte
                  columnas={
                  this.props.columnas.filter((c)=>{
                    if(currentUser.filter(c=> c.plataforma.id === 1711).length){
                      return !['variables.cuenta_espejo', 'eventos', 'idMovimientoTipo.nombre'].includes(c.columna)
                    }else{
                      return !['variables.cuenta_espejo', 'eventos'].includes(c.columna)
                    }
                  })
                  }
                /> }
              />
            </div>
            { this.state.movimiento.idPlataforma && [61, 1711].includes(this.state.movimiento.idPlataforma.id) && this.state.movimiento.id?//plataforma_evidencia_archivo
              <span class="badge">
                <Button
                  size="sm"
                  RootComponent="a"
                  color="info"
                  onClick={() => this.setState({ showVisualizadorArchivos: true })}
                >
                  <span class="badge">
                    <Icon link={true} name="image" />
                    {" "}Evidencias POD'S
                  </span>
                </Button>
              </span>
            : null}
            { this.state.movimiento.idPlataforma && [61, 1711].includes(this.state.movimiento.idPlataforma.id) && this.state.movimiento.id?//plataforma_evidencia_archivo
              <VisualizadorArchivos
                show={this.state.showVisualizadorArchivos}
                onHide={() => this.setState({ showVisualizadorArchivos: false })}
                conf={1}
                fecha={timeToYearmonthDay(new Date(this.state.movimiento.creationDate))}
                nombre={this.state.movimiento? (1+"_"+this.state.movimiento.idPlataforma.id+"_"+this.state.movimiento.id): ""}
              />
            : null}
            {/* {
              controlador ? 
            
            <div className="iconNotifications">
              <Notification checked={this.state.checked} listItems={this.state.listaAlertas ? this.state.listaAlertas : []}  actualizaEstatusAlertas={this.actualizaEstatusAlertas} ></Notification>
            </div> 
            
            : null} */}
                  
                     
          </div>
        </div>

     
       { (isNaN(this.props.gpsTipo) &&  !this.state.isloading) && (transportista || controlador)  ?
         <div className="container otd-container">
            <DashboardTransportista
            lista = {this.state.elementos ? this.state.elementos.filter(m=> this.state.plataforma.value?  m.idPlataforma?.id === this.state.plataforma.value : true ): []}
            filtrados = {this.filtrosAplicados}
            sinFiltrar = {this.state.elementosSinfiltrar}
            cambioPlataforma = {this.state.plataforma}
            plataforma = {this.state.plataforma.value}
            transportista={transportista}
            banderaRefresca = {this.state.updateData}
            refresca={this.refresca}
            eliminaFiltros={false}

            />

             { 
            <CSVImporter movimientos={this.props} plataformaSeleccionada={this.state.plataforma}/>
            }

          </div> : ""
       }



       <div className="row" >
             
             {this.state.isloading ? (
              <LoadingScreen
                loading={this.state.isloading}
              />
            ):null}
      </div>
          
        
        <div className="bg-light container-full-height">
          <TablePageable            
            titulo={
              <div>
                Movimientos
                { this.getFuncionalidadGeneral("movimientosFinalizados") ?
                  <div className="d-inline-flex align-items-center ml-3 form-check form-switch">
                    <Form.Switch
                      type="Checkbox"
                      checked={this.state.activos}
                      onChange={this.changeActivos}
                    />
                    <label className="form-check-label ms-2">
                      {this.state.activos
                        ? "Movimientos Activos"
                        : "Movimientos Finalizados"}
                    </label>
                  </div>
                  : null
                }
                { this.getFuncionalidadGeneral("movimientosFinalizados") && !this.state.activos ?
                  <div className="d-inline-flex align-items-center ml-3">
                    <span className="width-35-percent">
                      <input
                        type="date"
                        name="fecha1"
                        value={this.state.fecha1}
                        onChange={this.onChangeFecha1}
                      />
                    </span>
                    <span className="ml-2 mr-2"> - </span>
                    <span className="width-35-percent">
                      <input
                        type="date"
                        name="fecha2"
                        value={this.state.fecha2}
                        onChange={this.onChangeFecha2}
                      />
                    </span>
                    <Button
                      pill
                      size="sm"
                      outline
                      color="primary"
                      className="ml-2"
                      onClick={() => this.buscar()}
                    >
                      <Icon name="refresh-cw" />
                    </Button>
                  </div>
                  : null
                }
                { this.state.activos?
                  <div className="d-flex justify-content-between align-items-center mb-3 p-3">
                    <div className="d-flex align-items-center gap-3">
                      <div className="d-flex align-items-center">
                        <Form.Switch
                          checked={this.state.autoRefresh}
                          onChange={this.toggleAutoRefresh}
                        />
                        <label className="ms-2">Auto-refresh</label>
                      </div>
                      <div className="d-flex align-items-center ml-1">
                        <label className="me-2">Intervalo (seg): </label>
                        <input
                          type="number"
                          value={this.state.refreshInterval}
                          onChange={this.handleIntervalChange}
                          min="10"
                          max="300"
                          className="form-control ml-1 width-80px"
                        />
                      </div>
                      {this.state.lastUpdate && (
                        <small className="text-muted ml-1">
                          Última actualización: {this.state.lastUpdate}
                        </small>
                      )}
                      {this.state.obtenerMovimientosWaiting?
                        <Icon name="loader" className="fa-spin" />
                      :null}
                    </div>
                  </div>
                  :null
                }
              </div>}
            lista={ this.state.elementos ? this.state.elementos.filter(m=> this.state.plataforma.value?  m.idPlataforma?.id === this.state.plataforma.value : true ) : [] }
            columnas={ this.obtenerColumnas()
              /*[ Modificar  para acciones
                { 
                  columna: "id",
                  label: "Id",
                  //enClick:(e) => setCurrentMovimiento(e), //enClickDisabled: (e)=> false,//e.idSolicitud === 303? false: true,
                  //form: (e)=> <i className="fa fa-edit" style={{"font-size": "24px"}}><p style={{fontSize: "16px"}}>{e.idSolicitud}</p></i>
                },
                { columna: "idMovimiento", label: "idMovimiento" },
                { columna: "po", label: "Po", splitBy:";" },
                { columna: "contenedor", label: "Contenedor", splitBy:";" },
                { columna: "contenedorTipo", label: "Tipo contenedor" },
                { columna: "contenedorSize", label: "Tamaño de Contenedor" },
                { columna: "idOperacionTipo.nombre", label: "Tipo de operacion" },
                { columna: "idMovimientoTipo.nombre", label: "Tipotipo de movimiento" },
                { columna: "idTransportista.nombre", label: "Transportista" },
                { columna: "idCliente.nombre", label: "Cliente" },
              ]*/
            }
            id="id"
            selected={(e) => this.setState({ movimiento: e}) }
            csvname="Reporte"
            resaltarFuncion={(e)=> {
              if([71,1711].includes(e.idPlataforma?.id)){
                for( let h of ['citaProgramadaTerminal', 'citaProgramada','horaMaximaSalida'] ){
                  const resp= validarHorarios(e, h);
                  if(resp.vencida)
                    return resp.vencida;
                }
              }
              return false;
            }}
            resaltarColor={(e)=>{
              if([61,1711].includes(e.idPlataforma?.id) && !transportista){
                for( let h of ['citaProgramadaTerminal', 'citaProgramada','horaMaximaSalida'] ){
                  const resp= validarHorarios(e, h);
                  if(resp.vencida){
                    return resp.fondo;
                  }
                }
              }
              return null;
            }}
            paginacion={true}
            elementosPorPagina={10}
          />
        
        </div>
        {this.state.ruteadorModal && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)' }} onClick={() => this.setState({ ruteadorModal: null })} />
            <div style={{ position: 'relative', width: '90vw', height: '80vh', background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.3)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 16px', borderBottom: '1px solid #eee' }}>
                <b>Ruteador</b>
                <button onClick={() => this.setState({ ruteadorModal: null })} style={{ border: 'none', background: 'none', fontSize: 20, cursor: 'pointer' }}>✕</button>
              </div>
              <div style={{ height: 'calc(100% - 45px)' }}>
                <RuteadorContent
                  initialOrigen={this.state.ruteadorModal.origen}
                  initialOrigenCoords={this.state.ruteadorModal.origenCoords}
                  initialDestino={this.state.ruteadorModal.destino}
                  gpsIds={this.state.ruteadorModal.gpsIds}
                  movId={this.state.ruteadorModal.movId}
                  height="100%"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    movimientos_naviera_object:
      state.catalogos_reducer.movimientos_naviera_object,
    movimientosTipo_object: state.catalogos_reducer.movimientosTipo_object,
    clientes_object: state.catalogos_reducer.clientes_object,
    navieras_object: state.catalogos_reducer.navieras_object,
    operacionesEstatus_object:
      state.catalogos_reducer.operacionesEstatus_object,
    operacionesTipo_object: state.catalogos_reducer.operacionesTipo_object,
    otd_object: state.catalogos_reducer.otd_object,
    plataformas_object: state.catalogos_reducer.plataformas_object,
    rutasEstatus_object: state.catalogos_reducer.rutasEstatus_object,
    transportistas_object: state.catalogos_reducer.transportistas_object,
    corredores_object: state.catalogos_reducer.corredores_object,
    funcionalidades_object: state.catalogos_reducer.funcionalidades_object,
    privilegios_object: state.catalogos_reducer.privilegios_object,
    operadores_object: state.catalogos_reducer.operadores_object,
    updateStatusMensaje_Object: state.catalogos_reducer.update_mensaje,
    etiquetas_object: state.catalogos_reducer.etiquetas_object,
    serviceFailure_object: state.catalogos_reducer.serviceFailure_object,
  };
}
function mapDispachToProps(dispach) {
  return {
    movimientos_naviera_update: (elementos) =>
      dispach(ACTIONS.elementos_movimientos_naviera_imput(elementos)),
    updateStatusMensaje: (status) => dispach(ACTIONS.update_mensaje(status)),
    movimientosTipo_update: (elementos) =>
      dispach(ACTIONS.elementos_movimientosTipo_imput(elementos)),
    clientes_update: (elementos) =>
      dispach(ACTIONS.elementos_clientes_imput(elementos)),
    navieras_update: (elementos) =>
      dispach(ACTIONS.elementos_navieras_imput(elementos)),
    operacionesEstatus_update: (elementos) =>
      dispach(ACTIONS.elementos_operacionesEstatus_imput(elementos)),
    operacionesTipo_update: (elementos) =>
      dispach(ACTIONS.elementos_operacionestipo_imput(elementos)),
    otd_update: (elementos) => dispach(ACTIONS.elementos_otd_imput(elementos)),
    plataformas_update: (elementos) =>
      dispach(ACTIONS.elementos_plataformas_imput(elementos)),
    rutasEstatus_update: (elementos) =>
      dispach(ACTIONS.elementos_rutasEstatus_imput(elementos)),
    transportistas_update: (elementos) =>
      dispach(ACTIONS.elementos_transportistas_imput(elementos)),
    corredores_update: (elementos) =>
      dispach(ACTIONS.elementos_corredores_imput(elementos)),
    funcionalidades_update: (elementos) =>
      dispach(ACTIONS.elementos_funcionalidades_imput(elementos)),
    privilegios_update: (elementos) =>
      dispach(ACTIONS.elementos_privilegios_imput(elementos)),
    operadores_update: (elementos) =>
      dispach(ACTIONS.elementos_operadores_imput(elementos)),
    etiquetas_update: (elementos) =>
      dispach(ACTIONS.elementos_etiquetas_imput(elementos)),
    serviceFaulure_update: (elementos) =>
      dispach(ACTIONS.elementos_servicefailure_imput(elementos)),
  };
}
export default connect(
  mapStateToProps,
  mapDispachToProps
)(Catalogo);
